import React, { useState, useEffect, useRef, useCallback } from "react";

// ── Google Apps Script Web API ──────────────────────────
const GAS_URL = "https://script.google.com/macros/s/AKfycbzOvugAw5RXDcVX47k9mSwJloHzZ9OQVL_LMVhMX5mLiVyIh9wf8MlHvUUFyNvfwD6Qkw/exec";

// デバイスID生成（端末ごとに固定のID）
function getDeviceId() {
  try {
    let id = localStorage.getItem("otto_device_id");
    if (!id) {
      id = "dev_" + Date.now() + "_" + Math.random().toString(36).slice(2,8);
      localStorage.setItem("otto_device_id", id);
    }
    return id;
  } catch { return "dev_unknown"; }
}
const DEVICE_ID = getDeviceId();

// GASへのPOST
function gasPost(body) {
  if (!GAS_URL) return Promise.resolve({ ok: false });
  return fetch(GAS_URL, {
    method: "POST",
    body: JSON.stringify(body),
  }).then(r => r.json()).catch(() => ({ ok: false }));
}
// GASからのGET
function gasGet(params) {
  if (!GAS_URL) return Promise.resolve({ ok: false });
  return new Promise((resolve) => {
    const cbName = "_gasCallback_" + Date.now();
    const query  = Object.entries({ ...params, callback: cbName })
      .map(([k,v]) => `${k}=${encodeURIComponent(v)}`).join("&");
    const script = document.createElement("script");
    const timer  = setTimeout(() => {
      delete window[cbName];
      document.body.removeChild(script);
      resolve({ ok: false, error: "timeout" });
    }, 10000);
    window[cbName] = (data) => {
      clearTimeout(timer);
      delete window[cbName];
      document.body.removeChild(script);
      resolve(data);
    };
    script.src = `${GAS_URL}?${query}`;
    script.onerror = () => {
      clearTimeout(timer);
      delete window[cbName];
      resolve({ ok: false, error: "script error" });
    };
    document.body.appendChild(script);
  });
}

// EmailJS設定
const EMAILJS_SERVICE_ID = "service_x40rvtf";
const EMAILJS_TEMPLATE_ID = "template_4yq5e4a";
const EMAILJS_PUBLIC_KEY = "Y4EI4d46SUQceHjbr";
const NOTIFY_EMAIL = "bluesky.ari150842@gmail.com";

const sendNotification = (type, name, details) => {
  fetch("https://api.emailjs.com/api/v1.0/email/send", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      service_id: EMAILJS_SERVICE_ID,
      template_id: EMAILJS_TEMPLATE_ID,
      user_id: EMAILJS_PUBLIC_KEY,
      template_params: {
        type, name, details,
        datetime: new Date().toLocaleString("ja-JP"),
      }
    })
  })
  .then(r => console.log("通知送信:", r.status))
  .catch(e => console.log("通知エラー:", e));
};

// Firebase未接続（ローカル動作モード）
const db = null;
const push = () => {};
const ref = () => {};

const FARM = {
  name: "オットモンテ ブルーベリー・ガーデン",
  tagline: "ottoはイタリア語の「８」、monteは「山」で八ヶ岳を意味しています。",
  description: "四季折々の美しい八ヶ岳とその大地の恵み、日照時間日本一の北杜市明野町と大泉町で約1,000本のブルーベリーを化学肥料不使用で育てています。感動の甘さ！のブルーベリーを摘み取り体験、生果実の販売・卸、冷凍果実の販売、加工品製造・販売でお楽しみいただけます。是非、ブルーベリー・ガーデンへ遊びにお越しください！",
  address: "山梨県北杜市明野町上手3030-2",
  owner: "代表　有村 淳",
  tel: "080-9547-6109",
  email: "bluesky.ari150842@gmail.com",
  closed: "土・日営業（予約優先）、平日相談可",
  season: "6月20日（土）〜8月30日（日）",
  mapUrl: "https://maps.google.com/?cid=12188532585256920193",
  fbUrl: "https://www.facebook.com/otto8monte",
  igUrl: "https://www.instagram.com/otto3monte",
  lineUrl: "https://lin.ee/Dam8Dzf",
  shopUrl: "https://ottomonte.stores.jp/",
  rating: 5.0, ratingCount: 24,
  photo: "/IMG-6950.jpg",
};

const GALLERY = [
  { src:"/250609MAP.png", caption:"農園マップ", tag:"農園マップ" },
  { src:"/Cafe1.JPG", caption:"八ヶ岳を望む農園カフェ", tag:"農園Cafe" },
  { src:"/IMG-1333.jpg", caption:"500円玉サイズの極大粒！", tag:"大粒ベリー" },
  { src:"/IMG-1557.jpg", caption:"青と赤、色とりどりの品種", tag:"多品種栽培" },
  { src:"/IMG-2131.JPG", caption:"農園カフェのタルト", tag:"カフェ" },
  { src:"/blueberry.jpeg", caption:"メンディト — 手のひら一杯", tag:"品種紹介" },
];

// 圃場マップ画像（publicに追加次第反映）
const FIELD_MAP_IMAGES = {
  "圃場B":  "/MAP_FARM_B.png",
  "圃場C1": "/MAP_FARM_C1.png",
  "圃場C2": "/MAP_FARM_C2.png",
  "圃場D":  "/MAP_FARM_D.png",
  "圃場E":  "/MAP_FARM_E.png",
  "圃場F":  "/MAP_FARM_F.png",
};

// コースのスタイル定義
const COURSE_STYLES = {
  A1: { label:"A1コース", color:"#e11d48", bg:"#fff1f2", border:"#fda4af" },
  B1: { label:"B1コース", color:"#0891b2", bg:"#ecfeff", border:"#67e8f9" },
};

// フォールバック用デフォルトコース（GAS未設定時に使用）
const COURSES = [
  {
    id: "A1",
    label: "A1コース",
    color: "#e11d48",
    bg: "#fff1f2",
    border: "#fda4af",
    description: "圃場Bの大粒エメラルドからスタート！カフェ前のC1を経て農園Eへ。",
    stops: [
      { num: "①", field: "圃場B",  variety: "エメラルド",    farmMap:"/MAP_FARM_B.png" },
      { num: "②", field: "圃場C1", variety: "フロリダスター", farmMap:"/MAP_FARM_C1.png" },
      { num: "③", field: "圃場E",  variety: "OPI",           farmMap:"/MAP_FARM_E.png" },
      { num: "④", field: "圃場E",  variety: "トワイライト",  farmMap:"/MAP_FARM_E.png" },
    ]
  },
  {
    id: "B1",
    label: "B1コース",
    color: "#0891b2",
    bg: "#ecfeff",
    border: "#67e8f9",
    description: "圃場Eのフレッシュな早生品種からスタート！圃場B・C1へと巡るコース。",
    stops: [
      { num: "①", field: "圃場E",  variety: "OPI",           farmMap:"/MAP_FARM_E.png" },
      { num: "②", field: "圃場E",  variety: "トワイライト",  farmMap:"/MAP_FARM_E.png" },
      { num: "③", field: "圃場B",  variety: "エメラルド",    farmMap:"/MAP_FARM_B.png" },
      { num: "④", field: "圃場C1", variety: "フロリダスター", farmMap:"/MAP_FARM_C1.png" },
    ]
  },
];

const CALENDAR = [
  { no:1,  variety:"OPI",            type:"ハイブッシュ系", period:"6月中旬〜7月上旬", status:"early", cx:163, cy:138 },
  { no:2,  variety:"エメラルド",      type:"ハイブッシュ系", period:"6月中旬〜7月上旬", status:"early", cx:256, cy:118 },
  { no:3,  variety:"ミレニア",        type:"ハイブッシュ系", period:"6月中旬〜7月上旬", status:"early", cx:321, cy:100 },
  { no:4,  variety:"フロリダスター",  type:"ハイブッシュ系", period:"6月中旬〜7月上旬", status:"early", cx:189, cy:165 },
  { no:5,  variety:"トワイライト",    type:"ハイブッシュ系", period:"6月中旬〜7月上旬", status:"early", cx:396, cy:125 },
  { no:6,  variety:"チャンドラー",    type:"ハイブッシュ系", period:"7月上旬〜8月上旬", status:"early",  cx:489, cy:215 },
  { no:7,  variety:"レガシー",        type:"ハイブッシュ系", period:"7月上旬〜8月上旬", status:"early",  cx:431, cy:258 },
  { no:8,  variety:"ブルーレイ",      type:"ハイブッシュ系", period:"7月上旬〜8月上旬", status:"early",  cx:476, cy:411 },
  { no:9,  variety:"バークレイ",      type:"ハイブッシュ系", period:"7月上旬〜8月上旬", status:"early",  cx:359, cy:453 },
  { no:10, variety:"カロライン",      type:"ハイブッシュ系", period:"7月上旬〜8月上旬", status:"early",  cx:441, cy:303 },
  { no:11, variety:"ブリギッタ",      type:"ハイブッシュ系", period:"7月上旬〜8月上旬", status:"early",  cx:519, cy:478 },
  { no:12, variety:"エリザベス",      type:"ハイブッシュ系", period:"7月上旬〜8月上旬", status:"early",  cx:509, cy:353 },
  { no:13, variety:"ピンクレモネード",type:"ハイブッシュ系", period:"7月上旬〜8月上旬", status:"early",  cx:206, cy:293 },
  { no:14, variety:"レイトブルー",    type:"ハイブッシュ系", period:"7月上旬〜8月上旬", status:"early",  cx:419, cy:441 },
  { no:15, variety:"クライマックス",  type:"ラビットアイ系", period:"8月上旬〜9月上旬", status:"early",  cx:171, cy:235 },
  { no:16, variety:"ブルージェム",    type:"ラビットアイ系", period:"8月上旬〜9月上旬", status:"early",  cx:381, cy:273 },
  { no:17, variety:"デライト",        type:"ラビットアイ系", period:"8月上旬〜9月上旬", status:"early",  cx:459, cy:193 },
  { no:18, variety:"メンディト",      type:"ラビットアイ系", period:"8月上旬〜9月上旬", status:"early",  cx:544, cy:518 },
  { no:19, variety:"ティフブルー",    type:"ラビットアイ系", period:"8月上旬〜9月上旬", status:"early",  cx:229, cy:488 },
];

const COFFEE = [
  { name:"エチオピア",   cx:198, cy:480, blend:false },
  { name:"ケニア",       cx:229, cy:138, blend:false },
  { name:"タンザニア",   cx:169, cy:303, blend:false },
  { name:"コロンビア",   cx:229, cy:326, blend:false },
  { name:"コスタリカ",   cx:199, cy:196, blend:false },
  { name:"ペルー",       cx:269, cy:456, blend:false },
  { name:"グアテマラ",   cx:352, cy:276, blend:false },
  { name:"ブラジル",     cx:429, cy:426, blend:false },
  { name:"マンデリン",   cx:509, cy:156, blend:false },
  { name:"大泉ブレンド", cx:379, cy:166, blend:true  },
];

const MENU_ITEMS = [
  { id:"smoothie",  name:"濃厚ブルーベリースムージー", price:800, emoji:"🫐", category:"おすすめ" },
  { id:"latte_k",   name:"黒糖アイスカフェラテ",       price:600, emoji:"🧋", category:"おすすめ" },
  { id:"matcha",    name:"抹茶アイスラテ",             price:600, emoji:"🍵", category:"おすすめ" },
  { id:"cassis",    name:"カシスジュース",             price:450, emoji:"🍇", category:"おすすめ" },
  { id:"coffee",    name:"自家焙煎アイス珈琲",        price:450, emoji:"☕", category:"定番" },
  { id:"coffee_h",  name:"自家焙煎ホット珈琲",         price:450, emoji:"☕", category:"定番" },
  { id:"cafeore",   name:"自家焙煎アイスカフェオレ",  price:500, emoji:"🥛", category:"定番" },
  { id:"softcream", name:"オリジナルソフトアイス（摘み採り割引）", price:200, emoji:"🍦", category:"定番" },
  { id:"tart",      name:"オリジナルタルト",          price:450, emoji:"🍰", category:"定番" },
  { id:"pudding",   name:"オリジナルミルクプリン",    price:400, emoji:"🍮", category:"定番" },
  { id:"muffin",    name:"オリジナルブルーベリーマフィン", price:400, emoji:"🧁", category:"定番" },
  { id:"bb_takeout",    name:"摘み採り持ち帰りブルーベリー(100g)", price:450,  emoji:"🫐", category:"お土産" },
  { id:"bb_takeout_s",  name:"摘み採り持ち帰りブルーベリー(50g)",  price:225,  emoji:"🫐", category:"お土産" },
  { id:"vinegar",     name:"ブルーベリービネガーシロップ体験",   price:1500, emoji:"🍶", category:"お土産" },
  { id:"jam",         name:"ブルーベリージャム",               price:800,  emoji:"🫙", category:"お土産" },
  { id:"beans",       name:"珈琲豆(100g)",                    price:750,  emoji:"☕", category:"お土産" },
  { id:"cafeobase",   name:"カフェオレベース",                 price:1500, emoji:"🥛", category:"お土産" },
  { id:"drip",        name:"ドリップバッグ",                   price:150,  emoji:"☕", category:"お土産" },
];

const PRICE_ADULT = 2800;
const PRICE_CHILD = 800;
const PRICE_INFANT = 0;

const REVIEWS = [
  { text:"たくさんの種類のブルーベリーを食べられます。種類によってこんなに味が違うのか！と毎回それぞれのおいしさに驚かされます。ブルーベリー狩り以外にもアイス、コーヒーなど美味しいものがたくさんあり、幸せな時間を過ごさせていただきました。", author:"常連のお客様" },
  { text:"This will be our third year! We look forward to it every year. The blueberry ice cream, tarts, and coffee are all so delicious that we often end up staying for a long time!", author:"リピーターのお客様" },
  { text:"オーナーさんがとても親切で、品種ごとの特徴や食べ頃の見分け方を丁寧に教えてくれます。ブルーベリー畑からの眺めも最高です。", author:"ご家族のお客様" },
  { text:"子どもたちが夢中になってブルーベリーを摘んでいました！ソフトアイスも絶品で、また来年も必ず来ます。八ヶ岳の景色も最高でした。", author:"子連れファミリーのお客様" },
  { text:"自家焙煎のコーヒーがとても美味しく、ブルーベリーとの相性も抜群でした。農園の雰囲気がとても良く、ゆっくりと贅沢な時間を過ごせました。", author:"カフェ好きのお客様" },
  { text:"化学肥料不使用のブルーベリーは甘さが全然違います。子どもに安心して食べさせられるのも嬉しいです。毎年夏の恒例行事になっています！", author:"健康志向のお客様" },
  { text:"八ヶ岳を眺めながらブルーベリー摘み、最高のひとときでした。スタッフの方がとても丁寧に説明してくれて、初めてでも安心して楽しめました。", author:"初来園のお客様" },
  { text:"ブルーベリータルトが絶品！生のブルーベリーをたっぷり使っていて、見た目も味も大満足です。お土産にジャムも買って帰りました。", author:"スイーツ好きのお客様" },
];

const TABS = [
  { id:"home",     label:"ホーム"   },
  { id:"calendar", label:"食べ頃"   },
  { id:"cafe",     label:"カフェ"   },
  { id:"stamp",    label:"スタンプ" },
];

const statusConfig = {
  early:{ label:"まだ待ち🖐️", color:"#92400e", bg:"#fef3c7", border:"#fcd34d" },
  good: { label:"食べ頃 ✨", color:"#1e40af", bg:"#dbeafe", border:"#93c5fd" },
  peak: { label:"最盛期 🏆", color:"#166534", bg:"#dcfce7", border:"#86efac" },
  late: { label:"まもなく終了🙇‍♂️",      color:"#6b21a8", bg:"#f3e8ff", border:"#d8b4fe" },
};
const typeConfig = {
  "ハイブッシュ系":{ bg:"#f0fdf4", color:"#166534" },
  "ラビットアイ系":{ bg:"#faf5ff", color:"#6b21a8" },
};

const CourseSection = () => {
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedStop, setSelectedStop] = useState(null);
  
  return (
    <div>
      <div style={{ background:"linear-gradient(135deg,#f0fdf4,#dcfce7)", border:"1.5px solid #86efac", borderRadius:16, padding:"1rem", marginBottom:"1rem" }}>
        <div style={{ fontWeight:800, color:"#166534", fontSize:"0.9rem", marginBottom:"0.3rem" }}>🗺️ 本日のおすすめコース</div>
        <div style={{ color:"#4b7c59", fontSize:"0.78rem" }}>コースをタップするとマップと詳細が表示されます</div>
      </div>
      {COURSES.map(course=>(
        <div key={course.id}>
          <button onClick={()=>setSelectedCourse(selectedCourse?.id===course.id?null:course)}
            style={{ width:"100%", background:selectedCourse?.id===course.id?course.bg:"#fff", border:`2px solid ${selectedCourse?.id===course.id?course.color:course.border}`, borderRadius:16, padding:"1rem", marginBottom:"0.5rem", textAlign:"left", cursor:"pointer", fontFamily:"inherit", transition:"all 0.2s", boxShadow:"0 2px 8px rgba(0,0,0,0.06)" }}>
            <div style={{ display:"flex", alignItems:"center", gap:"0.7rem", marginBottom:"0.5rem" }}>
              <div style={{ width:36, height:36, borderRadius:"50%", background:course.color, display:"flex", alignItems:"center", justifyContent:"center", color:"#fff", fontWeight:900, fontSize:"0.82rem", flexShrink:0 }}>{course.id}</div>
              <div>
                <div style={{ fontWeight:800, color:course.color, fontSize:"1rem" }}>{course.label}</div>
                <div style={{ color:"#6b7280", fontSize:"0.75rem" }}>{course.description}</div>
              </div>
            </div>
            <div style={{ display:"flex", gap:"0.4rem", flexWrap:"wrap" }}>
              {course.stops.map((s,i)=>(
                <span key={i} style={{ background:course.color, color:"#fff", fontSize:"0.72rem", fontWeight:700, padding:"0.2rem 0.6rem", borderRadius:99 }}>{s.num}{s.field} {s.variety}</span>
              ))}
            </div>
          </button>
          {selectedCourse?.id===course.id&&(
            <div style={{ background:"#fff", border:`1.5px solid ${course.border}`, borderRadius:16, padding:"1rem", marginBottom:"1rem", animation:"fadeIn 0.3s ease" }}>
              <div style={{ fontWeight:800, color:course.color, fontSize:"0.85rem", marginBottom:"0.7rem" }}>📍 圃場マップ</div>
              <div style={{ position:"relative", borderRadius:12, overflow:"hidden", marginBottom:"0.8rem" }}>
                <img src="/250609MAP.png" alt="農園マップ" style={{ width:"100%", display:"block", borderRadius:12 }}/>
                {course.stops.map((s,i)=>(
                  <div key={i} style={{ position:"absolute", left:`${s.mapX}%`, top:`${s.mapY}%`, transform:"translate(-50%,-50%)", zIndex:10 }}>
                    <div style={{ width:28, height:28, borderRadius:"50%", background:course.color, border:"2.5px solid #fff", display:"flex", alignItems:"center", justifyContent:"center", color:"#fff", fontWeight:900, fontSize:"0.7rem", boxShadow:"0 2px 6px rgba(0,0,0,0.3)" }}>{s.num}</div>
                    <div style={{ background:"rgba(255,255,255,0.92)", borderRadius:6, padding:"0.1rem 0.35rem", fontSize:"0.6rem", fontWeight:700, color:course.color, whiteSpace:"nowrap", marginTop:"1px", boxShadow:"0 1px 3px rgba(0,0,0,0.2)", textAlign:"center" }}>{s.field}</div>
                  </div>
                ))}
              </div>
              <div style={{ fontWeight:800, color:"#1f2937", fontSize:"0.85rem", marginBottom:"0.5rem" }}>🫐 コース詳細（圃場名をタップで圃場マップ表示）</div>
              {course.stops.map((s,i)=>(
                <div key={i}>
                  <div onClick={()=>setSelectedStop(selectedStop===`${course.id}-${i}`?null:`${course.id}-${i}`)}
                    style={{ display:"flex", alignItems:"center", gap:"0.7rem", padding:"0.6rem 0", borderBottom:"1px solid #f3f4f6", cursor:"pointer" }}>
                    <div style={{ width:28, height:28, borderRadius:"50%", background:course.color, display:"flex", alignItems:"center", justifyContent:"center", color:"#fff", fontWeight:900, fontSize:"0.75rem", flexShrink:0 }}>{s.num}</div>
                    <div style={{ flex:1 }}>
                      <div style={{ fontWeight:700, color:"#1f2937", fontSize:"0.88rem" }}>{s.field}　{s.variety}</div>
                    </div>
                    <span style={{ color:course.color, fontSize:"0.75rem", fontWeight:700 }}>{selectedStop===`${course.id}-${i}`?"▲ 閉じる":"🗺️ 圃場MAP"}</span>
                  </div>
                  {selectedStop===`${course.id}-${i}`&&(
                    <div style={{ padding:"0.7rem 0", animation:"fadeIn 0.3s ease" }}>
                      <img src={s.farmMap} alt={s.field} style={{ width:"100%", borderRadius:10, display:"block", boxShadow:"0 2px 8px rgba(0,0,0,0.1)" }}/>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

const BlueberryChart = () => {
  const [tooltip, setTooltip] = useState(null);
  const W=340, H=340;
  const scaleX=(cx)=>(cx-60)*W/560;
  const scaleY=(cy)=>(cy-60)*H/560;
  return (
    <div style={{ background:"#fff", borderRadius:16, padding:"1rem", boxShadow:"0 2px 10px rgba(0,0,0,0.06)", marginBottom:"1rem" }}>
      <div style={{ fontWeight:800, color:"#166534", fontSize:"0.9rem", marginBottom:"0.4rem" }}>🫐 品種 味わいチャート</div>
      <div style={{ position:"relative" }}>
        <svg width="100%" viewBox={`0 0 ${W} ${H}`} style={{ display:"block" }}>
          <rect x="0" y="0" width={W/2} height={H/2} fill="#e3f2fd" opacity="0.4"/>
          <rect x={W/2} y="0" width={W/2} height={H/2} fill="#fff8e1" opacity="0.4"/>
          <rect x="0" y={H/2} width={W/2} height={H/2} fill="#e3f2fd" opacity="0.25"/>
          <rect x={W/2} y={H/2} width={W/2} height={H/2} fill="#fff8e1" opacity="0.25"/>
          <defs>
            <marker id="ba" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="4" markerHeight="4" orient="auto"><path d="M2 1L8 5L2 9" fill="none" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round"/></marker>
            <marker id="ba2" viewBox="0 0 10 10" refX="2" refY="5" markerWidth="4" markerHeight="4" orient="auto"><path d="M8 1L2 5L8 9" fill="none" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round"/></marker>
          </defs>
          <line x1="6" y1={H/2} x2={W-6} y2={H/2} stroke="#9ca3af" strokeWidth="1" markerEnd="url(#ba)" markerStart="url(#ba2)"/>
          <line x1={W/2} y1="6" x2={W/2} y2={H-6} stroke="#9ca3af" strokeWidth="1" markerEnd="url(#ba)" markerStart="url(#ba2)"/>
          <line x1={W/2} y1="6" x2={W/2} y2={H-6} stroke="#e5e7eb" strokeWidth="0.5" strokeDasharray="3,3"/>
          <line x1="6" y1={H/2} x2={W-6} y2={H/2} stroke="#e5e7eb" strokeWidth="0.5" strokeDasharray="3,3"/>
          <text x="18" y={H/2-4} fontSize="8" fill="#9ca3af" fontFamily="sans-serif">甘酸っぱい</text>
          <text x={W-52} y={H/2-4} fontSize="8" fill="#9ca3af" fontFamily="sans-serif">濃厚な甘み</text>
          <text x={W/2+3} y="13" fontSize="8" fill="#9ca3af" fontFamily="sans-serif">さっぱり</text>
          <text x={W/2+3} y={H-3} fontSize="8" fill="#9ca3af" fontFamily="sans-serif">コク深い</text>
          {CALENDAR.map(item=>{
            const px=scaleX(item.cx), py=scaleY(item.cy);
            const isActive=tooltip?.no===item.no;
            return (
              <g key={item.no} style={{ cursor:"pointer" }} onClick={()=>setTooltip(isActive?null:item)}>
                <text x={px} y={py} textAnchor="middle" fontSize={isActive?"20":"16"} style={{ userSelect:"none" }}>🫐</text>
                <text x={px} y={py+13} textAnchor="middle" fontSize="7" fill="#6b7280" fontFamily="sans-serif">{item.variety}</text>
              </g>
            );
          })}
        </svg>
        {tooltip&&(
          <div style={{ position:"absolute", top:8, left:"50%", transform:"translateX(-50%)", background:"rgba(17,24,39,0.88)", color:"#fff", borderRadius:10, padding:"0.5rem 0.9rem", fontSize:"0.78rem", whiteSpace:"nowrap", zIndex:10, pointerEvents:"none" }}>
            <div style={{ fontWeight:700 }}>{tooltip.variety}</div>
            <div style={{ color:"#d1fae5", fontSize:"0.7rem" }}>{tooltip.type}</div>
            <div style={{ color:"#fde68a", fontSize:"0.7rem" }}>📆 {tooltip.period}</div>
          </div>
        )}
      </div>
      <p style={{ color:"#9ca3af", fontSize:"0.68rem", textAlign:"center", margin:"0.3rem 0 0" }}>🫐 をタップすると品種情報が表示されます</p>
    </div>
  );
};

const CoffeeChart = () => {
  const [tooltip, setTooltip] = useState(null);
  const W=340, H=300;
  const scaleX=(cx)=>(cx-60)*W/560;
  const scaleY=(cy)=>(cy-60)*H/560;
  return (
    <div style={{ background:"#fff", borderRadius:16, padding:"1rem", boxShadow:"0 2px 10px rgba(0,0,0,0.06)", marginBottom:"1rem" }}>
      <div style={{ fontWeight:800, color:"#78350f", fontSize:"0.9rem", marginBottom:"0.4rem" }}>☕ 自家焙煎コーヒー 味わいチャート</div>
      <div style={{ position:"relative" }}>
        <svg width="100%" viewBox={`0 0 ${W} ${H}`} style={{ display:"block" }}>
          <rect x="0" y="0" width={W/2} height={H/2} fill="#e8f5e9" opacity="0.45"/>
          <rect x={W/2} y="0" width={W/2} height={H/2} fill="#fff3e0" opacity="0.45"/>
          <rect x="0" y={H/2} width={W/2} height={H/2} fill="#e3f2fd" opacity="0.35"/>
          <rect x={W/2} y={H/2} width={W/2} height={H/2} fill="#fce4ec" opacity="0.25"/>
          <defs>
            <marker id="ca" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="4" markerHeight="4" orient="auto"><path d="M2 1L8 5L2 9" fill="none" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round"/></marker>
            <marker id="ca2" viewBox="0 0 10 10" refX="2" refY="5" markerWidth="4" markerHeight="4" orient="auto"><path d="M8 1L2 5L8 9" fill="none" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round"/></marker>
          </defs>
          <line x1="6" y1={H/2} x2={W-6} y2={H/2} stroke="#9ca3af" strokeWidth="1" markerEnd="url(#ca)" markerStart="url(#ca2)"/>
          <line x1={W/2} y1="6" x2={W/2} y2={H-6} stroke="#9ca3af" strokeWidth="1" markerEnd="url(#ca)" markerStart="url(#ca2)"/>
          <line x1={W/2} y1="6" x2={W/2} y2={H-6} stroke="#e5e7eb" strokeWidth="0.5" strokeDasharray="3,3"/>
          <line x1="6" y1={H/2} x2={W-6} y2={H/2} stroke="#e5e7eb" strokeWidth="0.5" strokeDasharray="3,3"/>
          <text x="16" y={H/2-4} fontSize="8" fill="#9ca3af" fontFamily="sans-serif">酸　味</text>
          <text x={W-38} y={H/2-4} fontSize="8" fill="#9ca3af" fontFamily="sans-serif">苦　味</text>
          <text x={W/2+3} y="13" fontSize="8" fill="#9ca3af" fontFamily="sans-serif">コク深い</text>
          <text x={W/2+3} y={H-3} fontSize="8" fill="#9ca3af" fontFamily="sans-serif">あっさり</text>
          {COFFEE.map(item=>{
            const px=scaleX(item.cx), py=scaleY(item.cy);
            const isActive=tooltip?.name===item.name;
            return (
              <g key={item.name} style={{ cursor:"pointer" }} onClick={()=>setTooltip(isActive?null:item)}>
                <text x={px} y={py} textAnchor="middle" fontSize={isActive?"20":"16"} style={{ userSelect:"none" }}>{item.blend?"🫘":"☕"}</text>
                <text x={px} y={py+13} textAnchor="middle" fontSize="7" fill={item.blend?"#92400e":"#6b7280"} fontFamily="sans-serif" fontWeight={item.blend?"600":"400"}>{item.name}</text>
              </g>
            );
          })}
        </svg>
        {tooltip&&(
          <div style={{ position:"absolute", top:8, left:"50%", transform:"translateX(-50%)", background:"rgba(17,24,39,0.88)", color:"#fff", borderRadius:10, padding:"0.5rem 0.9rem", fontSize:"0.78rem", whiteSpace:"nowrap", zIndex:10, pointerEvents:"none" }}>
            <div style={{ fontWeight:700 }}>{tooltip.name}</div>
            <div style={{ color:"#fde68a", fontSize:"0.7rem" }}>{tooltip.blend?"🫘 ブレンド":"☕ シングルオリジン"}</div>
          </div>
        )}
      </div>
      <div style={{ display:"flex", gap:"1rem", justifyContent:"center", marginTop:"0.4rem" }}>
        <span style={{ fontSize:"0.72rem", color:"#6b7280" }}>☕ シングルオリジン</span>
        <span style={{ fontSize:"0.72rem", color:"#92400e", fontWeight:600 }}>🫘 ブレンド</span>
      </div>
    </div>
  );
};

const ReviewSection = () => {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? REVIEWS : REVIEWS.slice(0,5);
  return (
    <div style={{ background:"#fff", borderRadius:18, padding:"1.2rem", boxShadow:"0 2px 12px rgba(0,0,0,0.07)" }}>
      <div style={{ fontWeight:800, color:"#1f2937", fontSize:"0.95rem", marginBottom:"0.8rem" }}>💬 お客様の声</div>
      {visible.map((r,i)=>(
        <div key={i} style={{ borderBottom:i<visible.length-1?"1px solid #f3f4f6":"none", paddingBottom:"0.8rem", marginBottom:"0.8rem" }}>
          <div style={{ color:"#374151", fontSize:"0.83rem", lineHeight:1.7 }}>「{r.text}」</div>
          <div style={{ color:"#9ca3af", fontSize:"0.75rem", marginTop:"0.3rem", textAlign:"right" }}>— {r.author}</div>
        </div>
      ))}
      {REVIEWS.length>5&&(
        <button onClick={()=>setShowAll(!showAll)} style={{ width:"100%", background:"#f0fdf4", color:"#2d6a4f", border:"1.5px solid #86efac", borderRadius:10, padding:"0.6rem", fontWeight:700, fontSize:"0.85rem", cursor:"pointer", fontFamily:"inherit", marginTop:"0.2rem" }}>
          {showAll?"▲ 閉じる":`▼ すべて見る（全${REVIEWS.length}件）`}
        </button>
      )}
    </div>
  );
};

// ── スタンプラリー ─────────────────────────────
// QRコード用英語キー → 日本語表示名 対応マップ
const VARIETY_MAP = {
  "OPI":           "OPI",
  "Emerald":       "エメラルド",
  "Millennia":     "ミレニア",
  "FloridaStar":   "フロリダスター",
  "Twilight":      "トワイライト",
  "Chandler":      "チャンドラー",
  "Legacy":        "レガシー",
  "Blueray":       "ブルーレイ",
  "Barkley":       "バークレイ",
  "Caroline":      "カロライン",
  "Brigitta":      "ブリギッタ",
  "Elizabeth":     "エリザベス",
  "PinkLemonade":  "ピンクレモネード",
  "LateBlue":      "レイトブルー",
  "Climax":        "クライマックス",
  "BlueGem":       "ブルージェム",
  "Delight":       "デライト",
  "Mendito":       "メンディト",
  "Tifblue":       "ティフブルー",
};

// CALENDAR の variety（日本語）→ 英語キー の逆引きマップ
const VARIETY_TO_KEY = Object.fromEntries(
  Object.entries(VARIETY_MAP).map(([k, v]) => [v, k])
);

const STAMP_KEYS = Object.keys(VARIETY_MAP); // 英語キー19種
const TOTAL = STAMP_KEYS.length; // 19

const COUPONS = [
  {
    id: "bronze",
    threshold: 5,
    label: "5種制覇！",
    emoji: "🥉",
    title: "ブロンズクーポン",
    benefit: "次回ご入園料 100円引き",
    note: "1回の来園で達成可能！",
    color: "#92400e",
    bg: "#fef3c7",
    border: "#fcd34d",
    code: "OM-B5",
  },
  {
    id: "silver",
    threshold: 10,
    label: "10種制覇！",
    emoji: "🥈",
    title: "シルバークーポン",
    benefit: "次回ドリンク 1杯 無料",
    note: "2回以上の来園が必要です",
    color: "#1e40af",
    bg: "#dbeafe",
    border: "#93c5fd",
    code: "OM-S10",
  },
  {
    id: "gold",
    threshold: TOTAL,
    label: "全19種制覇！",
    emoji: "🥇",
    title: "ゴールドクーポン",
    benefit: "次回ご入園料 無料！",
    note: "3回以上の来園が必要です",
    color: "#854d0e",
    bg: "#fefce8",
    border: "#facc15",
    code: "OM-G19",
  },
];

const LS_KEY        = "otto_stamps";  // スタンプ保存キー
const LS_KEY_SURVEY = "otto_survey";  // アンケート保存キー {englishKey: optionId}
const LS_KEY_TALLY  = "otto_tally";  // 全体集計キー {optionId: count}

function loadStamps() {
  try { const r = localStorage.getItem(LS_KEY); return r ? JSON.parse(r) : []; } catch { return []; }
}
function saveStamps(arr) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(arr)); } catch {}
}
function loadSurvey() {
  try { const r = localStorage.getItem(LS_KEY_SURVEY); return r ? JSON.parse(r) : {}; } catch { return {}; }
}
function loadTally() {
  try { const r = localStorage.getItem(LS_KEY_TALLY); return r ? JSON.parse(r) : {great:0,excellent:0,neutral:0}; } catch { return {great:0,excellent:0,neutral:0}; }
}
function saveSurveyAndTally(surveyMap, optionId) {
  try {
    localStorage.setItem(LS_KEY_SURVEY, JSON.stringify(surveyMap));
    const tally = loadTally();
    tally[optionId] = (tally[optionId] || 0) + 1;
    localStorage.setItem(LS_KEY_TALLY, JSON.stringify(tally));
  } catch {}
}

// Top3品種表示コンポーネント（GASから取得）
// 圃場ごとのマップ上座標（%）- 250609_ブルーベリーMAP画像基準
const FIELD_MAP_COORDS = {
  "農園B":  { x: 80, y: 30 },
  "圃場B":  { x: 80, y: 30 },
  "農園C1": { x: 54, y: 40 },
  "圃場C1": { x: 54, y: 40 },
  "農園C2": { x: 39, y: 38 },
  "圃場C2": { x: 39, y: 38 },
  "農園D":  { x: 82, y: 53 },
  "圃場D":  { x: 82, y: 53 },
  "農園E":  { x: 11, y: 44 },
  "圃場E":  { x: 11, y: 44 },
  "農園F":  { x: 50, y: 72 },
  "圃場F":  { x: 50, y: 72 },
};

// マップ画像URL（日本語ファイル名をエンコード）
const FARM_MAP_URL = "/250609MAP.png";

// GASからコース設定を取得して表示するコンポーネント
const DynamicCourses = () => {
  const [gasCourses, setGasCourses] = useState(null);
  const [selCourse,  setSelCourse]  = useState(null);
  const [selField,   setSelField]   = useState(null);

  useEffect(() => {
    if (!GAS_URL) { setGasCourses({}); return; }
    gasGet({ action: "courses" })
      .then(d => setGasCourses(d.ok ? d.courses : {}))
      .catch(() => setGasCourses({}));
  }, []);

  const courses = (() => {
    if (!gasCourses || !Object.keys(gasCourses).length) return COURSES;
    return ["A1","B1"].map(id => {
      const gc = gasCourses[id];
      const st = COURSE_STYLES[id];
      if (!gc) return null;
      return {
        id, label:st.label, color:st.color, bg:st.bg, border:st.border,
        description: gc.stops.map(s=>s.field).filter((v,i,a)=>a.indexOf(v)===i).join(" → ") + " を巡るコース",
        stops: gc.stops.map((s,i) => ({
          num: ["①","②","③","④","⑤","⑥","⑦","⑧"][i] || `(${i+1})`,
          numIdx: i+1,
          field: s.field,
          variety: s.varietyJp || s.variety,
          farmMap: FIELD_MAP_IMAGES[s.field] || null,
        })),
      };
    }).filter(Boolean);
  })();

  if (gasCourses === null) return (
    <div style={{ textAlign:"center", padding:"2rem", color:"#9ca3af", fontSize:"0.85rem" }}>コース情報を読み込み中...</div>
  );

  return (
    <>
      {/* コース選択ボタン */}
      <div style={{ display:"flex", gap:"0.6rem", marginBottom:"1rem" }}>
        {courses.map(c => (
          <button key={c.id} onClick={()=>setSelCourse(selCourse?.id===c.id ? null : c)}
            style={{ flex:1, background:selCourse?.id===c.id?c.color:"#fff", color:selCourse?.id===c.id?"#fff":c.color, border:`2px solid ${c.color}`, borderRadius:14, padding:"0.7rem 0.5rem", fontWeight:800, fontSize:"0.88rem", cursor:"pointer", fontFamily:"inherit", transition:"all 0.2s" }}>
            {c.label}
          </button>
        ))}
      </div>

      {/* 選択コース詳細 */}
      {selCourse && (
        <div style={{ background:selCourse.bg, border:`1.5px solid ${selCourse.border}`, borderRadius:16, padding:"1rem", marginBottom:"1rem", animation:"fadeIn 0.3s ease" }}>
          <div style={{ fontWeight:800, color:selCourse.color, fontSize:"0.9rem", marginBottom:"0.3rem" }}>{selCourse.label}</div>
          <div style={{ color:"#6b7280", fontSize:"0.78rem", marginBottom:"0.8rem" }}>{selCourse.description}</div>

          {/* 使用圃場バッジ */}
          <div style={{ display:"flex", flexWrap:"wrap", gap:"0.3rem", marginBottom:"1rem" }}>
            {[...new Set(selCourse.stops.map(s=>s.field))].map(f=>(
              <span key={f} style={{ background:selCourse.color+"22", color:selCourse.color, border:`1px solid ${selCourse.color}44`, borderRadius:99, padding:"0.2rem 0.6rem", fontSize:"0.75rem", fontWeight:700 }}>{f}</span>
            ))}
          </div>

          {/* ── 全体マップ＋番号ピンオーバーレイ ── */}
          <div style={{ position:"relative", borderRadius:12, overflow:"hidden", marginBottom:"1rem", boxShadow:"0 2px 10px rgba(0,0,0,0.1)", background:"#f0fdf4" }}>
            <img
              src={FARM_MAP_URL}
              alt="農園全体マップ"
              style={{ width:"100%", display:"block" }}
              onError={e=>{ e.target.style.display="none"; e.target.nextSibling.style.display="block"; }}
            />
            <div style={{ display:"none", padding:"1rem", textAlign:"center", color:"#9ca3af", fontSize:"0.8rem" }}>
              マップ画像を読み込み中...
            </div>
            {/* 番号ピンをSVGオーバーレイで描画 */}
            <svg
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
              style={{ position:"absolute", inset:0, width:"100%", height:"100%" }}
            >
              {/* コースのルート線 */}
              {selCourse.stops.length >= 2 && (() => {
                const pts = selCourse.stops.map((s,i) => {
                  const base = FIELD_MAP_COORDS[s.field];
                  if (!base) return null;
                  const sameFieldBefore = selCourse.stops.slice(0,i).filter(p=>p.field===s.field).length;
                  return { x: base.x + sameFieldBefore*9, y: base.y + sameFieldBefore*-7 };
                }).filter(Boolean);
                if (pts.length < 2) return null;
                const d = pts.map((p,i) => `${i===0?"M":"L"}${p.x},${p.y}`).join(" ");
                return <path d={d} stroke={selCourse.color} strokeWidth="0.8" fill="none" strokeDasharray="2,1.5" opacity="0.7"/>;
              })()}
              {/* 番号ピン（同じ圃場は少しずらす） */}
              {selCourse.stops.map((s,i) => {
                const base = FIELD_MAP_COORDS[s.field];
                if (!base) return null;
                // 同じ圃場が何番目かカウントしてオフセット
                const sameFieldBefore = selCourse.stops.slice(0,i).filter(p=>p.field===s.field).length;
                const offsetX = sameFieldBefore * 9; // 同じ圃場ごとに右にずらす
                const offsetY = sameFieldBefore * -7; // 少し上にずらす
                const cx = base.x + offsetX;
                const cy = base.y + offsetY;
                return (
                  <g key={i}>
                    <circle cx={cx+0.3} cy={cy+0.3} r="4.5" fill="rgba(0,0,0,0.2)"/>
                    <circle cx={cx} cy={cy} r="4.5" fill={selCourse.color} stroke="#fff" strokeWidth="0.8"/>
                    <text x={cx} y={cy+1.3} textAnchor="middle" fontSize="3.8" fontWeight="bold" fill="#fff" fontFamily="sans-serif">{s.numIdx}</text>
                  </g>
                );
              })}
            </svg>
          </div>

          {/* 品種リスト */}
          {selCourse.stops.map((s,i) => (
            <div key={i}>
              <button onClick={()=>setSelField(selField===s.field+i ? null : s.field+i)}
                style={{ width:"100%", background:"#fff", border:`1px solid ${selCourse.border}`, borderRadius:10, padding:"0.6rem 0.8rem", marginBottom:"0.3rem", display:"flex", alignItems:"center", gap:"0.6rem", cursor:"pointer", fontFamily:"inherit", textAlign:"left" }}>
                <span style={{ background:selCourse.color, color:"#fff", borderRadius:99, width:26, height:26, display:"flex", alignItems:"center", justifyContent:"center", fontSize:"0.82rem", fontWeight:900, flexShrink:0 }}>{s.numIdx}</span>
                <div style={{ flex:1 }}>
                  <span style={{ fontWeight:700, color:"#1f2937", fontSize:"0.88rem" }}>{s.variety}</span>
                  <span style={{ marginLeft:"0.5rem", fontSize:"0.72rem", color:selCourse.color, fontWeight:600 }}>{s.field}</span>
                </div>
                {s.farmMap && <span style={{ fontSize:"0.7rem", color:"#9ca3af" }}>圃場MAP ▾</span>}
              </button>
              {selField===s.field+i && s.farmMap && (
                <div style={{ marginBottom:"0.5rem", borderRadius:10, overflow:"hidden", border:`1px solid ${selCourse.border}` }}>
                  <img src={s.farmMap} alt={s.field} style={{ width:"100%", display:"block" }}
                    onError={e=>{ e.target.style.display="none"; e.target.nextSibling.style.display="flex"; }}/>
                  <div style={{ display:"none", background:"#f9fafb", padding:"1.5rem", textAlign:"center", color:"#9ca3af", fontSize:"0.8rem" }}>
                    📍 {s.field}のマップ画像（準備中）
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

const Top3Section = () => {
  const [top3, setTop3]     = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!GAS_URL) { setLoading(false); return; }
    gasGet({ action: "top3" })
      .then(d => { if (d.ok && d.top3) setTop3(d.top3); })
      .finally(() => setLoading(false));
  }, []);
  if (loading) return null;
  if (!top3.length) return null;
  const medals = ["🥇","🥈","🥉"];
  const colors  = ["#854d0e","#374151","#92400e"];
  const bgs     = ["#fefce8","#f8fafc","#fef3c7"];
  const borders = ["#facc15","#d1d5db","#fcd34d"];
  return (
    <div style={{ background:"#fff", borderRadius:16, padding:"1rem", marginBottom:"1rem", boxShadow:"0 2px 10px rgba(0,0,0,0.06)" }}>
      <div style={{ fontWeight:800, color:"#374151", fontSize:"0.88rem", marginBottom:"0.7rem" }}>🏆 みんなに人気の品種 Top3</div>
      <div style={{ display:"flex", gap:"0.5rem" }}>
        {top3.map((t, i) => (
          <div key={t.variety} style={{ flex:1, background:bgs[i], border:`1.5px solid ${borders[i]}`, borderRadius:12, padding:"0.7rem 0.4rem", textAlign:"center" }}>
            <div style={{ fontSize:"1.3rem" }}>{medals[i]}</div>
            <div style={{ fontWeight:800, color:colors[i], fontSize:"0.78rem", marginTop:"0.2rem" }}>{t.varietyJp || t.variety}</div>
            <div style={{ fontSize:"0.65rem", color:"#9ca3af", marginTop:"0.2rem" }}>
              😊{t.great} 🤩{t.excellent}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const SURVEY_OPTIONS = [
  { id:"great",     label:"美味しかった",                    emoji:"😊", color:"#16a34a", bg:"#dcfce7", border:"#86efac" },
  { id:"excellent", label:"とても美味しかったので人に勧めたい！", emoji:"🤩", color:"#0891b2", bg:"#ecfeff", border:"#67e8f9" },
  { id:"neutral",   label:"そうでもなかった",                emoji:"😐", color:"#6b7280", bg:"#f3f4f6", border:"#d1d5db" },
];

const StampRally = ({ guestName }) => {
  const [stamps, setStamps]             = useState(() => loadStamps());
  const [surveyMap, setSurveyMap]       = useState(() => loadSurvey()); // {englishKey: optionId}
  const [scanning, setScanning]         = useState(false);
  const [scanResult, setScanResult]     = useState(null);
  const [newStamp, setNewStamp]         = useState(null);
  const [scanMsg, setScanMsg]           = useState("");
  const [isRescan, setIsRescan]         = useState(false); // 再スキャンフラグ
  const [earnedCoupon, setEarnedCoupon] = useState(null);
  const [shownCoupons, setShownCoupons] = useState([]);
  const [showTally, setShowTally]       = useState(false); // 集計表示
  const videoRef  = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  const rafRef    = useRef(null);

  const count = stamps.length;

  // カメラ停止
  const stopCamera = useCallback(() => {
    cancelAnimationFrame(rafRef.current);
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(t => t.stop());
      streamRef.current = null;
    }
    setScanning(false);
  }, []);

  // スタンプ付与（アンケートlocalStorage保存＋GAS送信・クーポン達成時のみEmailJS）
  const commitStamp = useCallback((englishKey, option, isUpdate) => {
    // アンケートをlocalStorageに保存
    const oldSurvey  = loadSurvey();
    const oldAnswer  = oldSurvey[englishKey] || null;
    const newSurveyMap = { ...oldSurvey, [englishKey]: option.id };
    saveSurveyAndTally(newSurveyMap, option.id);
    setSurveyMap(newSurveyMap);

    // GASにアンケート記録を送信
    gasPost({
      action: "survey",
      deviceId: DEVICE_ID,
      variety: englishKey,
      varietyJp: VARIETY_MAP[englishKey] || englishKey,
      answer: option.id,
      answerLabel: option.label,
      isUpdate: isUpdate || false,
      oldAnswer: oldAnswer,
    }).catch(() => {});

    if (isUpdate) return; // 再回答はスタンプ追加しない

    setStamps(prev => {
      if (prev.includes(englishKey)) return prev;
      const next = [...prev, englishKey];
      saveStamps(next);
      setNewStamp(englishKey);
      // クーポン達成チェック → 達成時のみEmailJS
      const earned = [...COUPONS].reverse().find(c => next.length >= c.threshold);
      if (earned && !shownCoupons.includes(earned.id)) {
        setShownCoupons(p => [...p, earned.id]);
        setEarnedCoupon(earned);
        fetch("https://api.emailjs.com/api/v1.0/email/send", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            service_id: EMAILJS_SERVICE_ID, template_id: EMAILJS_TEMPLATE_ID, user_id: EMAILJS_PUBLIC_KEY,
            template_params: {
              type: "🎯 " + earned.title + "達成",
              name: guestName || "ゲスト",
              details: `${earned.label} ${earned.benefit}\nコード: ${earned.code}\nスタンプ: ${next.length}/${TOTAL}`,
              datetime: new Date().toLocaleString("ja-JP"),
            }
          })
        }).catch(() => {});
      }
      return next;
    });
  }, [shownCoupons, guestName]);

  // アンケート選択 → 即反映（初回 or 再回答）
  const handleSurvey = useCallback((option) => {
    const englishKey = VARIETY_TO_KEY[scanResult] || scanResult;
    const isRescan   = stamps.includes(englishKey);
    commitStamp(englishKey, option, isRescan);
    setScanMsg(isRescan
      ? `🔄 ${VARIETY_MAP[englishKey] || scanResult} のアンケートを更新しました`
      : `🫐 ${VARIETY_MAP[englishKey] || scanResult} のスタンプを押しました！`
    );
    setScanResult(null);
    setIsRescan(false);
  }, [scanResult, stamps, commitStamp]);

  // URLパラメータから自動スタンプ
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const v = params.get("stamp");
    if (v) {
      const englishKey = VARIETY_TO_KEY[decodeURIComponent(v)] || decodeURIComponent(v);
      if (STAMP_KEYS.includes(englishKey)) {
        stopCamera();
        setIsRescan(stamps.includes(englishKey));
        setScanResult(englishKey);
      }
      window.history.replaceState({}, "", window.location.pathname);
    }
  }, [stopCamera]);

  // jsQR フレーム解析（startCamera より先に定義）
  const tick = useCallback(() => {
    const video = videoRef.current, canvas = canvasRef.current;
    if (!video || !canvas) return;
    const ctx = canvas.getContext("2d");
    canvas.width = video.videoWidth; canvas.height = video.videoHeight;
    ctx.drawImage(video, 0, 0);
    try {
      const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      if (window.jsQR) {
        const code = window.jsQR(imgData.data, imgData.width, imgData.height);
        if (code) {
          let raw = code.data.trim();
          if (raw.startsWith("stamp=")) raw = raw.replace("stamp=", "");
          try { const u = new URL(raw); raw = u.searchParams.get("stamp") || raw; } catch {}
          const englishKey = VARIETY_TO_KEY[decodeURIComponent(raw)] || decodeURIComponent(raw);
          cancelAnimationFrame(rafRef.current);
          if (streamRef.current) {
            streamRef.current.getTracks().forEach(t => t.stop());
            streamRef.current = null;
          }
          setScanning(false);
          if (STAMP_KEYS.includes(englishKey)) {
            setIsRescan(stamps.includes(englishKey)); // 再スキャンかどうか
            setScanResult(englishKey);
          } else {
            setScanMsg("❌ 無効なQRコードです");
          }
          return;
        }
      }
    } catch {}
    rafRef.current = requestAnimationFrame(tick);
  }, []);

  // カメラ起動
  const startCamera = useCallback(async () => {
    setScanMsg("");
    setScanResult(null);
    setScanning(true);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
      streamRef.current = stream;
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        await videoRef.current.play();
        rafRef.current = requestAnimationFrame(tick);
      }
    } catch {
      setScanMsg("カメラへのアクセスが拒否されました");
      setScanning(false);
    }
  }, [tick]);

  const achievedCoupons = COUPONS.filter(c => count >= c.threshold);

  return (
    <div style={{ animation:"fadeIn 0.4s ease" }}>

      {/* ヘッダー */}
      <div style={{ background:"linear-gradient(135deg,#166534,#2d6a4f)", padding:"2rem 1.5rem 1.5rem", textAlign:"center" }}>
        <div style={{ fontSize:"2.2rem", marginBottom:"0.3rem" }}>🎯</div>
        <h2 style={{ color:"#fff", fontWeight:900, margin:"0 0 0.3rem" }}>スタンプラリー</h2>
        <p style={{ color:"#b7e4c7", fontSize:"0.82rem", margin:0 }}>全19品種のブルーベリーを食べてスタンプをゲット！</p>
      </div>

      {/* ── アンケート画面（スキャン直後） ── */}
      {scanResult && (
        <div style={{ padding:"1rem 1.2rem" }}>
          <div style={{ background:"#fff", borderRadius:20, padding:"1.5rem", boxShadow:"0 4px 20px rgba(0,0,0,0.1)", animation:"zoomIn 0.3s ease" }}>
            <div style={{ textAlign:"center", marginBottom:"1.2rem" }}>
              <div style={{ fontSize:"2.8rem", marginBottom:"0.4rem" }}>{isRescan ? "🔄" : "🫐"}</div>
              {isRescan ? (
                <>
                  <div style={{ fontWeight:900, color:"#0891b2", fontSize:"1.1rem", marginBottom:"0.3rem" }}>
                    再度 {VARIETY_MAP[scanResult] || scanResult} がスキャンされました
                  </div>
                  <div style={{ color:"#6b7280", fontSize:"0.82rem" }}>アンケートをし直しますか？</div>
                </>
              ) : (
                <>
                  <div style={{ fontWeight:900, color:"#166534", fontSize:"1.2rem", marginBottom:"0.3rem" }}>
                    {VARIETY_MAP[scanResult] || scanResult} をスキャンしました
                  </div>
                  <div style={{ color:"#6b7280", fontSize:"0.82rem" }}>味はいかがでしたか？</div>
                </>
              )}
            </div>

            {/* アンケートボタン（常に表示） */}
            <div style={{ display:"flex", flexDirection:"column", gap:"0.55rem" }}>
              {SURVEY_OPTIONS.map(opt => (
                <button key={opt.id} onClick={() => handleSurvey(opt)}
                  style={{ background:opt.bg, border:"1.5px solid " + opt.border, borderRadius:14, padding:"0.9rem 1rem", display:"flex", alignItems:"center", gap:"0.8rem", cursor:"pointer", fontFamily:"inherit", textAlign:"left", width:"100%", transition:"transform 0.1s" }}
                  onMouseOver={e=>e.currentTarget.style.transform="scale(1.02)"}
                  onMouseOut={e=>e.currentTarget.style.transform="scale(1)"}
                >
                  <span style={{ fontSize:"1.6rem" }}>{opt.emoji}</span>
                  <span style={{ fontWeight:700, color:opt.color, fontSize:"0.95rem" }}>{opt.label}</span>
                </button>
              ))}
              {/* 再スキャン時はスキップボタンも表示 */}
              {isRescan && (
                <button onClick={() => { setScanResult(null); setIsRescan(false); }}
                  style={{ background:"#f3f4f6", border:"1px solid #e5e7eb", borderRadius:14, padding:"0.75rem 1rem", cursor:"pointer", fontFamily:"inherit", color:"#6b7280", fontWeight:600, fontSize:"0.88rem" }}>
                  そのまま保存（アンケートを変更しない）
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ── 通常画面（スタンプ一覧） ── */}
      {!scanResult && (
        <div style={{ padding:"1rem 1.2rem" }}>

          {/* 進捗バー */}
          <div style={{ background:"#fff", borderRadius:18, padding:"1.2rem", marginBottom:"1rem", boxShadow:"0 2px 12px rgba(0,0,0,0.07)" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"0.6rem" }}>
              <span style={{ fontWeight:800, color:"#166534", fontSize:"0.95rem" }}>🫐 スタンプ進捗</span>
              <span style={{ fontWeight:900, color:"#166534", fontSize:"1.3rem" }}>{count}<span style={{ fontSize:"0.8rem", color:"#9ca3af" }}>/{TOTAL}</span></span>
            </div>
            <div style={{ background:"#f0fdf4", borderRadius:99, height:14, overflow:"hidden", marginBottom:"0.5rem" }}>
              <div style={{ background:"linear-gradient(90deg,#16a34a,#4ade80)", height:"100%", width:(count/TOTAL*100)+"%", borderRadius:99, transition:"width 0.6s ease" }}/>
            </div>
            <div style={{ display:"flex", justifyContent:"space-between" }}>
              {COUPONS.map(c=>(
                <div key={c.id} style={{ textAlign:"center" }}>
                  <div style={{ fontSize:"0.72rem", color: count>=c.threshold ? c.color : "#d1d5db", fontWeight:700 }}>{c.emoji} {c.threshold}種</div>
                </div>
              ))}
            </div>
          </div>

          {/* QRスキャンボタン */}
          {!scanning ? (
            <button onClick={startCamera} style={{ width:"100%", background:"linear-gradient(135deg,#166534,#16a34a)", color:"#fff", border:"none", borderRadius:14, padding:"1rem", fontWeight:900, fontSize:"1rem", cursor:"pointer", fontFamily:"inherit", boxShadow:"0 4px 14px rgba(22,101,52,0.4)", marginBottom:"1rem", display:"flex", alignItems:"center", justifyContent:"center", gap:"0.6rem" }}>
              📷 QRコードをスキャンする
            </button>
          ) : (
            <div style={{ marginBottom:"1rem" }}>
              <div style={{ position:"relative", borderRadius:16, overflow:"hidden", background:"#000", marginBottom:"0.7rem" }}>
                <video ref={videoRef} style={{ width:"100%", display:"block", borderRadius:16 }} playsInline muted />
                <div style={{ position:"absolute", inset:0, display:"flex", alignItems:"center", justifyContent:"center", pointerEvents:"none" }}>
                  <div style={{ width:200, height:200, border:"3px solid #4ade80", borderRadius:12, boxShadow:"0 0 0 9999px rgba(0,0,0,0.5)" }}/>
                </div>
              </div>
              <canvas ref={canvasRef} style={{ display:"none" }}/>
              <button onClick={stopCamera} style={{ width:"100%", background:"#ef4444", color:"#fff", border:"none", borderRadius:12, padding:"0.7rem", fontWeight:700, fontSize:"0.9rem", cursor:"pointer", fontFamily:"inherit" }}>✕ キャンセル</button>
            </div>
          )}

          {/* スタンプ完了メッセージ */}
          {scanMsg && (
            <div style={{ background: scanMsg.startsWith("🫐") ? "#dcfce7" : scanMsg.startsWith("✅") ? "#fef9c3" : "#fee2e2", border: "1px solid " + (scanMsg.startsWith("🫐") ? "#86efac" : scanMsg.startsWith("✅") ? "#fde047" : "#fca5a5"), borderRadius:12, padding:"0.8rem 1rem", marginBottom:"1rem", fontWeight:700, fontSize:"0.9rem", color:"#1f2937", textAlign:"center", animation:"zoomIn 0.3s ease" }}>
              {scanMsg}
            </div>
          )}

          {/* クーポン達成モーダル */}
          {earnedCoupon && (
            <div onClick={()=>setEarnedCoupon(null)} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.75)", zIndex:2000, display:"flex", alignItems:"center", justifyContent:"center", padding:"1.5rem", animation:"zoomIn 0.3s ease" }}>
              <div onClick={e=>e.stopPropagation()} style={{ background:"#fff", borderRadius:24, padding:"2rem 1.5rem", width:"100%", maxWidth:380, textAlign:"center", boxShadow:"0 8px 40px rgba(0,0,0,0.25)" }}>
                <div style={{ fontSize:"3.5rem", marginBottom:"0.5rem" }}>{earnedCoupon.emoji}</div>
                <div style={{ fontWeight:900, fontSize:"1.5rem", color:earnedCoupon.color, marginBottom:"0.3rem" }}>{earnedCoupon.label}</div>
                <div style={{ fontWeight:800, fontSize:"1rem", color:"#1f2937", marginBottom:"1rem" }}>{earnedCoupon.title} 獲得！</div>
                <div style={{ background:earnedCoupon.bg, border:"2px solid "+earnedCoupon.border, borderRadius:16, padding:"1rem", marginBottom:"1rem" }}>
                  <div style={{ fontWeight:900, color:earnedCoupon.color, fontSize:"1.1rem" }}>{earnedCoupon.benefit}</div>
                  <div style={{ color:"#6b7280", fontSize:"0.78rem", marginTop:"0.4rem" }}>{earnedCoupon.note}</div>
                  <div style={{ color:"#9ca3af", fontSize:"0.75rem", marginTop:"0.4rem" }}>スタッフにこの画面をご提示ください</div>
                </div>
                <div style={{ background:"#f9fafb", borderRadius:12, padding:"0.7rem", marginBottom:"1rem" }}>
                  <div style={{ color:"#9ca3af", fontSize:"0.72rem", marginBottom:"0.2rem" }}>クーポンコード</div>
                  <div style={{ fontWeight:900, fontSize:"1.4rem", color:"#1f2937", letterSpacing:"0.1em" }}>{earnedCoupon.code}</div>
                </div>
                <button onClick={()=>setEarnedCoupon(null)} style={{ width:"100%", background:"#166534", color:"#fff", border:"none", borderRadius:12, padding:"0.8rem", fontWeight:700, fontSize:"0.95rem", cursor:"pointer", fontFamily:"inherit" }}>閉じる</button>
              </div>
            </div>
          )}

          {/* 獲得済みクーポン */}
          {achievedCoupons.length > 0 && (
            <div style={{ marginBottom:"1rem" }}>
              <div style={{ fontWeight:800, color:"#1f2937", fontSize:"0.9rem", marginBottom:"0.6rem" }}>🎁 獲得済みクーポン</div>
              {achievedCoupons.map(c=>(
                <div key={c.id} style={{ background:c.bg, border:"1.5px solid "+c.border, borderRadius:14, padding:"0.9rem 1rem", marginBottom:"0.5rem", display:"flex", alignItems:"center", gap:"0.8rem" }}>
                  <span style={{ fontSize:"1.8rem" }}>{c.emoji}</span>
                  <div style={{ flex:1 }}>
                    <div style={{ fontWeight:800, color:c.color, fontSize:"0.88rem" }}>{c.title}</div>
                    <div style={{ fontWeight:700, color:"#374151", fontSize:"0.85rem" }}>{c.benefit}</div>
                    <div style={{ color:"#9ca3af", fontSize:"0.72rem" }}>{c.note}　コード: {c.code}</div>
                  </div>
                  <button onClick={()=>setEarnedCoupon(c)} style={{ background:c.color, color:"#fff", border:"none", borderRadius:8, padding:"0.4rem 0.7rem", fontWeight:700, fontSize:"0.75rem", cursor:"pointer", fontFamily:"inherit" }}>表示</button>
                </div>
              ))}
            </div>
          )}

          {/* 次の目標 */}
          {COUPONS.filter(c=>count<c.threshold).length > 0 && (
            <div style={{ background:"#fff", borderRadius:16, padding:"1rem", marginBottom:"1rem", boxShadow:"0 2px 8px rgba(0,0,0,0.06)" }}>
              <div style={{ fontWeight:800, color:"#374151", fontSize:"0.88rem", marginBottom:"0.6rem" }}>🎯 次の目標</div>
              {COUPONS.filter(c=>count<c.threshold).map(c=>(
                <div key={c.id} style={{ display:"flex", alignItems:"center", gap:"0.7rem", padding:"0.5rem 0", borderBottom:"1px solid #f3f4f6" }}>
                  <span style={{ fontSize:"1.4rem" }}>{c.emoji}</span>
                  <div style={{ flex:1 }}>
                    <div style={{ fontWeight:700, color:"#374151", fontSize:"0.85rem" }}>{c.title}（{c.threshold}種）</div>
                    <div style={{ color:"#6b7280", fontSize:"0.78rem" }}>{c.benefit}</div>
                  </div>
                  <span style={{ fontWeight:700, color:c.color, fontSize:"0.82rem" }}>あと{c.threshold-count}種</span>
                </div>
              ))}
            </div>
          )}

          {/* スタンプカード */}
          <div style={{ background:"#fff", borderRadius:18, padding:"1rem", boxShadow:"0 2px 10px rgba(0,0,0,0.06)", marginBottom:"1rem" }}>
            <div style={{ fontWeight:800, color:"#166534", fontSize:"0.9rem", marginBottom:"0.8rem" }}>🫐 スタンプカード</div>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:"0.4rem" }}>
              {STAMP_KEYS.map(key => {
                const stamped   = stamps.includes(key);
                const isNew     = key === newStamp;
                const optId     = surveyMap[key];
                const opt       = SURVEY_OPTIONS.find(o => o.id === optId);
                return (
                  <div key={key} style={{ background: stamped ? "#dcfce7" : "#f9fafb", border:"1.5px solid "+(stamped?"#86efac":"#e5e7eb"), borderRadius:12, padding:"0.5rem 0.3rem", textAlign:"center", transition:"all 0.3s", transform: isNew ? "scale(1.08)" : "scale(1)" }}>
                    <div style={{ fontSize: stamped ? "1.3rem" : "1.1rem", marginBottom:"0.1rem", filter: stamped ? "none" : "grayscale(1) opacity(0.3)" }}>🫐</div>
                    <div style={{ fontSize:"0.58rem", fontWeight:700, color: stamped ? "#166534" : "#9ca3af", lineHeight:1.3 }}>{VARIETY_MAP[key]}</div>
                    <div style={{ fontSize:"0.52rem", color: stamped ? "#4ade80" : "#d1d5db", marginTop:"0.1rem" }}>{key}</div>
                    {stamped && opt && (
                      <div style={{ fontSize:"0.95rem", marginTop:"0.15rem" }} title={opt.label}>{opt.emoji}</div>
                    )}
                    {stamped && !opt && (
                      <div style={{ fontSize:"0.55rem", color:"#4ade80", fontWeight:700 }}>✓</div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          {/* みんなの人気品種 Top3（顧客向け） */}
          <Top3Section />

          {/* アンケート集計（ローカル・スタッフ用） */}
          <div style={{ background:"#fff", borderRadius:14, padding:"1rem", marginBottom:"0.6rem", boxShadow:"0 2px 8px rgba(0,0,0,0.05)" }}>
            <button onClick={() => setShowTally(p => !p)}
              style={{ width:"100%", display:"flex", alignItems:"center", justifyContent:"space-between", background:"none", border:"none", cursor:"pointer", fontFamily:"inherit", padding:0 }}>
              <span style={{ fontWeight:700, color:"#374151", fontSize:"0.85rem" }}>📊 この端末のアンケート集計</span>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                {showTally ? <polyline points="18 15 12 9 6 15"/> : <polyline points="6 9 12 15 18 9"/>}
              </svg>
            </button>
            {showTally && (() => {
              const tally = loadTally();
              const total = (tally.great||0) + (tally.excellent||0) + (tally.neutral||0);
              return (
                <div style={{ marginTop:"0.8rem" }}>
                  {SURVEY_OPTIONS.map(opt => {
                    const n = tally[opt.id] || 0;
                    const pct = total > 0 ? Math.round(n/total*100) : 0;
                    return (
                      <div key={opt.id} style={{ marginBottom:"0.6rem" }}>
                        <div style={{ display:"flex", justifyContent:"space-between", marginBottom:"0.2rem" }}>
                          <span style={{ fontSize:"0.82rem", color:opt.color, fontWeight:600 }}>{opt.emoji} {opt.label}</span>
                          <span style={{ fontSize:"0.82rem", fontWeight:700, color:"#374151" }}>{n}件 ({pct}%)</span>
                        </div>
                        <div style={{ background:"#f3f4f6", borderRadius:99, height:7, overflow:"hidden" }}>
                          <div style={{ background:opt.color, height:"100%", width:pct+"%", borderRadius:99, transition:"width 0.5s ease" }}/>
                        </div>
                      </div>
                    );
                  })}
                  <div style={{ color:"#9ca3af", fontSize:"0.72rem", textAlign:"right", marginTop:"0.3rem" }}>合計 {total}件</div>
                </div>
              );
            })()}
          </div>

          {/* スタンプのみリセット（来園者用） */}
          <button onClick={()=>{
            if(window.confirm("スタンプをリセットしますか？\n（アンケートのデータは残ります）")){
              saveStamps([]); setStamps([]);
              setShownCoupons([]); setNewStamp(null); setScanMsg("");
            }
          }} style={{ width:"100%", background:"#f3f4f6", color:"#9ca3af", border:"1px solid #e5e7eb", borderRadius:12, padding:"0.6rem", fontWeight:600, fontSize:"0.8rem", cursor:"pointer", fontFamily:"inherit" }}>
            🔄 スタンプをリセット
          </button>
        </div>
      )}
    </div>
  );
};


export default function App() {
  const [tab, setTab] = useState("home");
  const [filterType, setFilterType] = useState("すべて");
  const [calView, setCalView] = useState("course");
  const [gasVarieties, setGasVarieties] = useState({});

  useEffect(() => {
    if (!GAS_URL) return;
    // 食べ頃タブを開いたとき、または初回マウント時に取得
    gasGet({ action:"varieties" })
      .then(d => { if (d.ok && Object.keys(d.varieties).length > 0) setGasVarieties(d.varieties); })
      .catch(() => {});
  }, [tab]);
  const [cafeView, setCafeView] = useState("menu");
  const [galleryIdx, setGalleryIdx] = useState(0);
  const [lightbox, setLightbox] = useState(null);
  const [orders, setOrders] = useState({});         // 現在カート
  const [orderHistory, setOrderHistory] = useState([]); // 確定済み注文履歴
  const [orderSubmitted, setOrderSubmitted] = useState(false);
  const [showInfo, setShowInfo] = useState(false);  // 農園情報アコーディオン
  const [showCheckin, setShowCheckin] = useState(false); // 受付アコーディオン
  const [showLocal, setShowLocal] = useState(false); // 近隣情報アコーディオン

  const now = new Date();
  const dateStr = `${now.getFullYear()}年${now.getMonth()+1}月${now.getDate()}日（${"日月火水木金土"[now.getDay()]}）`;
  const timeStr = `${String(now.getHours()).padStart(2,"0")}:${String(now.getMinutes()).padStart(2,"0")}`;

  const [checkin, setCheckin] = useState({
    name:"", contact:"", contactType:"tel",
    gender:"", ageGroup:"",
    adults:0, children:0, infants:0,
    visitDate:dateStr, visitTime:timeStr,
    submitted:false,
  });

  const totalAdmission = checkin.adults*PRICE_ADULT + checkin.children*PRICE_CHILD;
  const totalOrder = MENU_ITEMS.reduce((sum,item)=>sum+(orders[item.id]||0)*item.price, 0);
  const totalAll = totalAdmission + totalOrder;

  const updateOrder = (id,delta) => {
    setOrders(prev=>{ const cur=prev[id]||0; return {...prev,[id]:Math.max(0,cur+delta)}; });
  };

  // GASから取得したステータスでCALENDARを上書き
  const dynamicCalendar = CALENDAR.map(c => ({
    ...c,
    status: gasVarieties[c.variety]?.status || c.status,
  }));
  const peakVarieties   = dynamicCalendar.filter(c=>c.status==="peak");
  const filteredCalendar = filterType==="すべて" ? dynamicCalendar : dynamicCalendar.filter(c=>c.type===filterType);
  const highbushCount = CALENDAR.filter(c=>c.type==="ハイブッシュ系").length;
  const rabbitCount   = CALENDAR.filter(c=>c.type==="ラビットアイ系").length;

  return (
    <div style={{ minHeight:"100vh", maxWidth:480, margin:"0 auto", background:"#fafaf7", fontFamily:"'Hiragino Maru Gothic Pro','Rounded Mplus 1c',sans-serif", paddingBottom:80 }}>
      <style>{`
        @keyframes fadeIn { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:none} }
        @keyframes berry  { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-6px)} }
        @keyframes zoomIn { from{opacity:0;transform:scale(0.92)} to{opacity:1;transform:scale(1)} }
        @keyframes stampPop { 0%{transform:scale(0.5);opacity:0} 70%{transform:scale(1.2)} 100%{transform:scale(1);opacity:1} }
        .card-hover:hover { transform:translateY(-2px); box-shadow:0 8px 24px rgba(0,0,0,0.10)!important; }
        .tab-btn:active { transform:scale(0.93); }
        .gallery-thumb { cursor:pointer; transition:transform 0.2s; }
        .gallery-thumb:hover { transform:scale(1.04); }
        input, select { font-family:inherit; }
      `}</style>

      {lightbox!==null&&(
        <div onClick={()=>setLightbox(null)} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.88)", zIndex:1000, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"1.5rem", animation:"zoomIn 0.2s ease" }}>
          <img src={GALLERY[lightbox].src} alt="" style={{ maxWidth:"100%", maxHeight:"75vh", borderRadius:16, objectFit:"contain" }}/>
          <div style={{ color:"#fff", fontWeight:700, marginTop:"1rem" }}>{GALLERY[lightbox].caption}</div>
          <div style={{ color:"rgba(255,255,255,0.5)", fontSize:"0.78rem", marginTop:"0.3rem" }}>タップして閉じる</div>
        </div>
      )}

      {/* HOME */}
      {tab==="home"&&(
        <div style={{ animation:"fadeIn 0.4s ease" }}>
          <div style={{ position:"relative", height:300, overflow:"hidden" }}>
            <img src={FARM.photo} alt="農園" style={{ width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 30%" }}/>
            <div style={{ position:"absolute", inset:0, background:"linear-gradient(to bottom,rgba(0,0,0,0) 30%,rgba(10,30,15,0.85) 100%)" }}/>
            <div style={{ position:"absolute", bottom:0, left:0, right:0, padding:"1.5rem" }}>
              <div style={{ display:"flex", alignItems:"flex-end", gap:"0.6rem", marginBottom:"0.4rem" }}>
                <span style={{ fontSize:"2rem", animation:"berry 3s ease-in-out infinite" }}>🫐</span>
                <div>
                  <div style={{ color:"rgba(255,255,255,0.65)", fontSize:"0.65rem", letterSpacing:"0.12em" }}>OTTO＊MONTE</div>
                  <h1 style={{ color:"#fff", fontSize:"1.35rem", fontWeight:900, margin:0, lineHeight:1.2 }}>ブルーベリー・ガーデン</h1>
                </div>
              </div>
              <div style={{ display:"flex", alignItems:"center", gap:"0.5rem", flexWrap:"wrap" }}>
                <span style={{ color:"#fbbf24" }}>★★★★★</span>
                <span style={{ color:"#fff", fontWeight:700, fontSize:"0.85rem" }}>5.0</span>
                <span style={{ color:"rgba(255,255,255,0.6)", fontSize:"0.75rem" }}>（24件）</span>
                <span style={{ background:"rgba(255,255,255,0.2)", color:"#fff", fontSize:"0.68rem", padding:"0.15rem 0.5rem", borderRadius:99 }}>🌱 化学農薬・肥料不使用</span>
              </div>
            </div>
          </div>
          <div style={{ background:"#2d6a4f", padding:"0.75rem 1.2rem" }}>
            <div style={{ textAlign:"center", color:"#fff", fontWeight:900, fontSize:"0.95rem", marginBottom:"0.2rem" }}>🫐 ブルーベリー摘み採り（食べ放題）🫐</div>
            <div style={{ textAlign:"center", color:"#b7e4c7", fontWeight:700, fontSize:"0.85rem", marginBottom:"0.4rem" }}>＜予定＞ 2026年 6月20日（土）〜 8月30日（日）</div>
            <div style={{ display:"flex" }}>
              {[{icon:"⏱️",text:"食べ放題40分"},{icon:"🛍️",text:"150g持帰り付(大人のみ)"},{icon:"🍦",text:"ソフトアイス割引特典",sub:"(通常450円が200円に！)"}].map((item,i,arr)=>(
                <div key={i} style={{ flex:1, textAlign:"center", borderRight:i<arr.length-1?"1px solid rgba(255,255,255,0.2)":"none" }}>
                  <div style={{ color:"#b7e4c7", fontSize:"0.65rem" }}>{item.icon}</div>
                  <div style={{ color:"#fff", fontWeight:700, fontSize:"0.73rem" }}>{item.text}</div>
                  {item.sub && <div style={{ color:"#fde68a", fontWeight:700, fontSize:"0.6rem", marginTop:"0.1rem" }}>{item.sub}</div>}
                </div>
              ))}
            </div>
          </div>
          <div style={{ padding:"1.2rem" }}>
            <div style={{ marginBottom:"1.2rem" }}>
              <div style={{ fontWeight:800, color:"#374151", fontSize:"0.85rem", marginBottom:"0.7rem" }}>📸 農園ギャラリー</div>
              <div style={{ position:"relative", borderRadius:16, overflow:"hidden", marginBottom:"0.5rem", boxShadow:"0 4px 16px rgba(0,0,0,0.12)" }}>
                <img src={GALLERY[galleryIdx].src} alt={GALLERY[galleryIdx].caption} onClick={()=>setLightbox(galleryIdx)} style={{ width:"100%", height:210, objectFit:"cover", cursor:"zoom-in", display:"block" }}/>
                <div style={{ position:"absolute", bottom:0, left:0, right:0, background:"linear-gradient(transparent,rgba(0,0,0,0.55))", padding:"0.8rem 1rem 0.6rem" }}>
                  <div style={{ color:"#fff", fontWeight:700, fontSize:"0.85rem" }}>{GALLERY[galleryIdx].caption}</div>
                </div>
              </div>
              <div style={{ display:"flex", gap:"0.4rem" }}>
                {GALLERY.map((g,i)=>(
                  <div key={i} className="gallery-thumb" onClick={()=>setGalleryIdx(i)} style={{ flex:1, borderRadius:10, overflow:"hidden", border:`2px solid ${i===galleryIdx?"#2d6a4f":"transparent"}` }}>
                    <img src={g.src} alt="" style={{ width:"100%", height:48, objectFit:"cover", display:"block" }}/>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ background:"#fff", borderRadius:16, padding:"1.1rem", marginBottom:"1rem", boxShadow:"0 2px 10px rgba(0,0,0,0.06)", borderLeft:"4px solid #2d6a4f" }}>
              <div style={{ color:"#2d6a4f", fontWeight:800, fontSize:"0.8rem", marginBottom:"0.4rem" }}>🌿 農園について</div>
              <p style={{ color:"#374151", fontSize:"0.83rem", lineHeight:1.75, margin:0 }}>
                <em style={{ color:"#166534", fontStyle:"normal", fontWeight:700 }}>「{FARM.tagline}」</em><br/>{FARM.description}
              </p>
            </div>
            {/* 摘み採り受付（アコーディオン）*/}
            <button onClick={()=>setShowCheckin(p=>!p)} style={{ width:"100%", background: showCheckin?"#ecfeff":"#fff", border:`1.5px solid ${showCheckin?"#0891b2":"#e5e7eb"}`, borderRadius:14, padding:"0.75rem 1rem", marginBottom:"0.6rem", display:"flex", alignItems:"center", gap:"0.7rem", cursor:"pointer", fontFamily:"inherit", textAlign:"left", transition:"all 0.2s" }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={showCheckin?"#0891b2":"#6b7280"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/>
                <rect x="9" y="3" width="6" height="4" rx="1"/>
                <line x1="9" y1="12" x2="15" y2="12"/>
                <line x1="9" y1="16" x2="13" y2="16"/>
              </svg>
              <div style={{ flex:1 }}>
                <div style={{ fontWeight:700, color:showCheckin?"#0891b2":"#374151", fontSize:"0.88rem" }}>
                  摘み採り受付
                  {checkin.submitted&&<span style={{ marginLeft:"0.5rem", background:"#0891b2", color:"#fff", fontSize:"0.65rem", padding:"0.1rem 0.45rem", borderRadius:99, fontWeight:700 }}>受付済</span>}
                </div>
                <div style={{ color:"#9ca3af", fontSize:"0.72rem" }}>
                  {checkin.submitted ? `${checkin.name}様　大人${checkin.adults}・小人${checkin.children}・幼児${checkin.infants}名` : "人数・代表者情報を入力する"}
                </div>
              </div>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                {showCheckin ? <polyline points="18 15 12 9 6 15"/> : <polyline points="6 9 12 15 18 9"/>}
              </svg>
            </button>
            {showCheckin&&(
              <div style={{ background:"#fff", borderRadius:16, padding:"1.2rem", marginBottom:"0.8rem", boxShadow:"0 2px 10px rgba(0,0,0,0.07)", animation:"fadeIn 0.3s ease", border:"1.5px solid #e0f2fe" }}>
                {checkin.submitted ? (
                  /* 受付完了表示 */
                  <div style={{ textAlign:"center", padding:"0.5rem 0" }}>
                    <div style={{ fontSize:"2rem", marginBottom:"0.5rem" }}>🫐</div>
                    <div style={{ fontWeight:900, color:"#0891b2", fontSize:"1.1rem", marginBottom:"0.3rem" }}>受付完了！</div>
                    <div style={{ color:"#374151", fontSize:"0.85rem", marginBottom:"0.2rem" }}>{checkin.name} 様</div>
                    <div style={{ color:"#6b7280", fontSize:"0.8rem", marginBottom:"0.8rem" }}>大人 {checkin.adults}名 / 小人 {checkin.children}名 / 幼児 {checkin.infants}名</div>
                    <div style={{ background:"#f0fdf4", border:"1.5px solid #86efac", borderRadius:12, padding:"0.7rem", marginBottom:"0.8rem" }}>
                      <div style={{ fontWeight:800, color:"#166534", fontSize:"0.95rem" }}>摘み採り料：¥{totalAdmission.toLocaleString()}</div>
                    </div>
                    <button onClick={()=>setCheckin({...checkin,submitted:false})} style={{ background:"#0891b2", color:"#fff", border:"none", borderRadius:10, padding:"0.55rem 1.4rem", fontWeight:700, cursor:"pointer", fontFamily:"inherit", fontSize:"0.85rem" }}>修正する</button>
                  </div>
                ) : (
                  /* 受付入力フォーム */
                  <>
                    {/* 日時 */}
                    <div style={{ background:"#ecfeff", border:"1px solid #67e8f9", borderRadius:10, padding:"0.5rem 0.8rem", marginBottom:"0.8rem", display:"flex", alignItems:"center", gap:"0.5rem" }}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0891b2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                      <div>
                        <div style={{ fontWeight:700, color:"#0891b2", fontSize:"0.82rem" }}>{checkin.visitDate}</div>
                        <div style={{ color:"#06b6d4", fontSize:"0.72rem" }}>受付時刻：{checkin.visitTime}</div>
                      </div>
                    </div>
                    {/* 名前 */}
                    <div style={{ marginBottom:"0.7rem" }}>
                      <label style={{ fontSize:"0.75rem", color:"#6b7280", fontWeight:600, display:"block", marginBottom:"0.25rem" }}>お名前 <span style={{ color:"#ef4444" }}>*</span></label>
                      <input value={checkin.name} onChange={e=>setCheckin({...checkin,name:e.target.value})} placeholder="例：有村 淳" style={{ width:"100%", padding:"0.55rem 0.8rem", borderRadius:10, border:"1.5px solid #e5e7eb", fontSize:"0.9rem", boxSizing:"border-box", outline:"none" }}/>
                    </div>
                    {/* 連絡先 */}
                    <div style={{ marginBottom:"0.7rem" }}>
                      <label style={{ fontSize:"0.75rem", color:"#6b7280", fontWeight:600, display:"block", marginBottom:"0.25rem" }}>連絡先</label>
                      <div style={{ display:"flex", gap:"0.4rem", marginBottom:"0.35rem" }}>
                        {["tel","email"].map(t=>(
                          <button key={t} onClick={()=>setCheckin({...checkin,contactType:t})} style={{ flex:1, padding:"0.35rem", borderRadius:8, border:`1.5px solid ${checkin.contactType===t?"#0891b2":"#e5e7eb"}`, background:checkin.contactType===t?"#ecfeff":"#fff", color:checkin.contactType===t?"#0891b2":"#6b7280", fontWeight:700, fontSize:"0.75rem", cursor:"pointer", fontFamily:"inherit" }}>
                            {t==="tel"?"電話番号":"メール"}
                          </button>
                        ))}
                      </div>
                      <input value={checkin.contact} onChange={e=>setCheckin({...checkin,contact:e.target.value})} placeholder={checkin.contactType==="tel"?"例：080-1234-5678":"例：example@email.com"} type={checkin.contactType==="tel"?"tel":"email"} style={{ width:"100%", padding:"0.55rem 0.8rem", borderRadius:10, border:"1.5px solid #e5e7eb", fontSize:"0.9rem", boxSizing:"border-box", outline:"none" }}/>
                    </div>
                    {/* 人数 */}
                    <div style={{ marginBottom:"0.8rem" }}>
                      <label style={{ fontSize:"0.75rem", color:"#6b7280", fontWeight:600, display:"block", marginBottom:"0.4rem" }}>摘み採り人数</label>
                      {[
                        { label:"大人", sub:"中学生以上 ¥2,800", key:"adults",  color:"#7c3aed" },
                        { label:"小人", sub:"3才〜小学生 ¥800",  key:"children",color:"#2563eb" },
                        { label:"幼児", sub:"2才以下 無料",       key:"infants", color:"#059669" },
                      ].map(row=>(
                        <div key={row.key} style={{ display:"flex", alignItems:"center", padding:"0.5rem 0", borderBottom:"1px solid #f3f4f6" }}>
                          <div style={{ flex:1 }}>
                            <div style={{ fontWeight:700, color:"#1f2937", fontSize:"0.88rem" }}>{row.label}</div>
                            <div style={{ fontSize:"0.7rem", color:"#6b7280" }}>{row.sub}</div>
                          </div>
                          <div style={{ display:"flex", alignItems:"center", gap:"0.4rem" }}>
                            <button onClick={()=>setCheckin(p=>({...p,[row.key]:Math.max(0,p[row.key]-1)}))} style={{ width:30, height:30, borderRadius:"50%", border:`1.5px solid ${row.color}`, background:"#fff", color:row.color, fontWeight:900, fontSize:"1.1rem", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}>−</button>
                            <span style={{ fontWeight:900, fontSize:"1.1rem", minWidth:24, textAlign:"center" }}>{checkin[row.key]}</span>
                            <button onClick={()=>setCheckin(p=>({...p,[row.key]:p[row.key]+1}))} style={{ width:30, height:30, borderRadius:"50%", border:"none", background:row.color, color:"#fff", fontWeight:900, fontSize:"1.1rem", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}>＋</button>
                          </div>
                        </div>
                      ))}
                      <div style={{ marginTop:"0.6rem", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                        <span style={{ fontSize:"0.8rem", color:"#6b7280" }}>合計 {checkin.adults+checkin.children+checkin.infants}名</span>
                        <span style={{ fontWeight:900, color:"#7c3aed", fontSize:"1rem" }}>¥{totalAdmission.toLocaleString()}</span>
                      </div>
                    </div>
                    {/* 受付ボタン */}
                    <button onClick={()=>{
                      if(!checkin.name){ alert("お名前を入力してください"); return; }
                      if(checkin.adults+checkin.children+checkin.infants===0){ alert("人数を入力してください"); return; }
                      // EmailJS通知
                      fetch("https://api.emailjs.com/api/v1.0/email/send",{
                        method:"POST", headers:{"Content-Type":"application/json"},
                        body:JSON.stringify({
                          service_id:EMAILJS_SERVICE_ID, template_id:EMAILJS_TEMPLATE_ID, user_id:EMAILJS_PUBLIC_KEY,
                          template_params:{
                            type:"🫐 摘み採り受付",
                            name:checkin.name,
                            details:`大人${checkin.adults}名 / 小人${checkin.children}名 / 幼児${checkin.infants}名　摘採料：¥${totalAdmission.toLocaleString()}\n連絡先(${checkin.contactType==="tel"?"電話":"メール"})：${checkin.contact}`,
                            datetime:new Date().toLocaleString("ja-JP"),
                          }
                        })
                      }).catch(()=>{});
                      // GASスプレッドシートにも記録
                      gasPost({
                        action:"checkin", deviceId:DEVICE_ID,
                        name:checkin.name, contact:checkin.contact, contactType:checkin.contactType,
                        adults:checkin.adults, children:checkin.children, infants:checkin.infants,
                        admission:totalAdmission, visitDate:checkin.visitDate,
                      }).catch(()=>{});
                      setCheckin({...checkin, submitted:true});
                    }} style={{ width:"100%", background:"linear-gradient(135deg,#0891b2,#06b6d4)", color:"#fff", border:"none", borderRadius:12, padding:"0.8rem", fontWeight:900, fontSize:"0.95rem", cursor:"pointer", fontFamily:"inherit", boxShadow:"0 3px 10px rgba(8,145,178,0.3)" }}>
                      受付を完了する ✓
                    </button>
                  </>
                )}
              </div>
            )}
            {/* クイックリンクカード */}
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0.8rem", marginBottom:"1rem" }}>
              {[
                { icon:(
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#2d6a4f" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/><circle cx="8" cy="15" r="1" fill="#2d6a4f"/><circle cx="12" cy="15" r="1" fill="#2d6a4f"/></svg>
                  ), title:"今の食べ頃", sub:"19品種を栽培中", tabId:"calendar", color:"#2d6a4f", bg:"#f0fdf4" },
                { icon:(
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#7c5c3e" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 8h1a4 4 0 010 8h-1"/><path d="M3 8h14v9a4 4 0 01-4 4H7a4 4 0 01-4-4V8z"/><line x1="6" y1="2" x2="6" y2="5"/><line x1="10" y1="2" x2="10" y2="5"/><line x1="14" y1="2" x2="14" y2="5"/></svg>
                  ), title:"カフェメニュー", sub:"ご注文はこちら", tabId:"cafe", color:"#7c5c3e", bg:"#fdf8f3" },
                { icon:(
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#be185d" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 001.97 1.61h9.72a2 2 0 001.97-1.61L23 6H6"/></svg>
                  ), title:"オンラインショップ", sub:"お土産・冷凍ベリー", tabId:"shop", color:"#be185d", bg:"#fdf2f8" },
                { icon:(
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0891b2" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="5"/><path d="M3 21h18"/><path d="M7 21v-4a5 5 0 0110 0v4"/></svg>
                  ), title:"スタンプラリー", sub:"品種制覇でクーポン！", tabId:"stamp", color:"#0891b2", bg:"#ecfeff" },
              ].map(item=>(
                <button key={item.title} className="card-hover" onClick={()=>item.tabId==="shop"?window.open(FARM.shopUrl,"_blank"):setTab(item.tabId)}
                  style={{ background:item.bg, border:`1.5px solid ${item.color}22`, borderRadius:16, padding:"1rem", textAlign:"left", cursor:"pointer", transition:"all 0.2s", boxShadow:"0 2px 8px rgba(0,0,0,0.06)" }}>
                  <div style={{ marginBottom:"0.4rem" }}>{item.icon}</div>
                  <div style={{ color:item.color, fontWeight:800, fontSize:"0.88rem" }}>{item.title}</div>
                  <div style={{ color:"#9ca3af", fontSize:"0.73rem", marginTop:"0.1rem" }}>{item.sub}</div>
                </button>
              ))}
            </div>
            {/* 次回予約ボタン */}
            <a href="https://ottomonte-linebot.vercel.app/reserve.html" target="_blank" rel="noopener noreferrer"
              style={{ boxSizing:"border-box", width:"100%", background:"#fff", border:"1.5px solid #e5e7eb", borderRadius:14, padding:"0.75rem 1rem", marginBottom:"0.6rem", display:"flex", alignItems:"center", gap:"0.7rem", cursor:"pointer", textDecoration:"none", transition:"all 0.2s" }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#166534" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
              <div style={{ flex:1 }}>
                <div style={{ fontWeight:700, color:"#374151", fontSize:"0.88rem" }}>次回の摘み採りを予約する</div>
                <div style={{ color:"#9ca3af", fontSize:"0.72rem" }}>オンライン予約はこちら</div>
              </div>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </a>

            {/* SNSボタン（最盛期の前） */}
            <button onClick={()=>setShowInfo(p=>!p)} style={{ width:"100%", background: showInfo?"#f9fafb":"#fff", border:`1.5px solid ${showInfo?"#d1d5db":"#e5e7eb"}`, borderRadius:14, padding:"0.75rem 1rem", marginBottom:"0.6rem", display:"flex", alignItems:"center", gap:"0.7rem", cursor:"pointer", fontFamily:"inherit", textAlign:"left", transition:"all 0.2s" }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={showInfo?"#374151":"#6b7280"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5"/>
                <circle cx="12" cy="12" r="4"/>
                <circle cx="17.5" cy="6.5" r="1" fill={showInfo?"#374151":"#6b7280"} stroke="none"/>
              </svg>
              <div style={{ flex:1 }}>
                <div style={{ fontWeight:700, color:"#374151", fontSize:"0.88rem" }}>SNS・お問い合わせ</div>
                <div style={{ color:"#9ca3af", fontSize:"0.72rem" }}>Instagram・LINE・Facebook・Shop</div>
              </div>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                {showInfo ? <polyline points="18 15 12 9 6 15"/> : <polyline points="6 9 12 15 18 9"/>}
              </svg>
            </button>
            {showInfo&&(
              <div style={{ marginBottom:"1rem", animation:"fadeIn 0.3s ease" }}>
                {/* SNS 2×2グリッド */}
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0.5rem", marginBottom:"0.5rem" }}>
                  {/* 左上：Instagram */}
                  <button onClick={()=>window.open(FARM.igUrl,"_blank")} style={{ background:"linear-gradient(135deg,#833ab4,#fd1d1d,#fcb045)", color:"#fff", border:"none", borderRadius:12, padding:"0.85rem 0.5rem", fontWeight:700, fontSize:"0.85rem", cursor:"pointer", fontFamily:"inherit", display:"flex", alignItems:"center", justifyContent:"center", gap:"0.45rem" }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="#fff" stroke="none"/></svg>
                    Instagram
                  </button>
                  {/* 右上：Facebook */}
                  <button onClick={()=>window.open(FARM.fbUrl,"_blank")} style={{ background:"#1877f2", color:"#fff", border:"none", borderRadius:12, padding:"0.85rem 0.5rem", fontWeight:700, fontSize:"0.85rem", cursor:"pointer", fontFamily:"inherit", display:"flex", alignItems:"center", justifyContent:"center", gap:"0.45rem" }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>
                    Facebook
                  </button>
                  {/* 左下：公式LINE */}
                  <button onClick={()=>window.open(FARM.lineUrl,"_blank")} style={{ background:"#06c755", color:"#fff", border:"none", borderRadius:12, padding:"0.85rem 0.5rem", fontWeight:700, fontSize:"0.85rem", cursor:"pointer", fontFamily:"inherit", display:"flex", alignItems:"center", justifyContent:"center", gap:"0.45rem" }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5C21 6.8 16.97 3 12 3S3 6.8 3 11.5c0 4.2 3.73 7.72 8.77 8.38.34.07.8.22.92.51.1.26.07.67.03.93l-.15.9c-.05.27-.22 1.06.93.58 1.14-.48 6.17-3.63 8.42-6.22C20.52 14.49 21 13.07 21 11.5z"/></svg>
                    公式LINE
                  </button>
                  {/* 右下：オンラインショップ */}
                  <button onClick={()=>window.open(FARM.shopUrl,"_blank")} style={{ background:"linear-gradient(135deg,#be185d,#ec4899)", color:"#fff", border:"none", borderRadius:12, padding:"0.85rem 0.5rem", fontWeight:700, fontSize:"0.85rem", cursor:"pointer", fontFamily:"inherit", display:"flex", alignItems:"center", justifyContent:"center", gap:"0.45rem" }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 001.97 1.61h9.72a2 2 0 001.97-1.61L23 6H6"/></svg>
                    Shop
                  </button>
                </div>
                {/* 住所・代表等 */}
                <div style={{ background:"#f9fafb", borderRadius:12, padding:"0.8rem 1rem" }}>
                  {[
                    {label:"住所", value:FARM.address, icon:<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="11" r="3"/><path d="M12 2a9 9 0 00-9 9c0 5.25 9 13 9 13s9-7.75 9-13a9 9 0 00-9-9z"/></svg>},
                    {label:"代表", value:FARM.owner, icon:<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>},
                    {label:"電話", value:FARM.tel, icon:<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8 19.79 19.79 0 01.22 1.22 2 2 0 012.22 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.09a16 16 0 006 6l.56-.56a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>},
                    {label:"営業", value:FARM.closed, icon:<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>},
                    {label:"シーズン", value:FARM.season, icon:<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>},
                  ].map((row,i,arr)=>(
                    <div key={i} style={{ display:"flex", gap:"0.55rem", alignItems:"flex-start", padding:"0.4rem 0", borderBottom:i<arr.length-1?"1px solid #e5e7eb":"none" }}>
                      <span style={{ marginTop:"0.2rem", flexShrink:0 }}>{row.icon}</span>
                      <div style={{ display:"flex", gap:"0.5rem", alignItems:"baseline", flexWrap:"wrap" }}>
                        <span style={{ color:"#9ca3af", fontSize:"0.68rem", flexShrink:0 }}>{row.label}</span>
                        <span style={{ color:"#374151", fontWeight:600, fontSize:"0.82rem" }}>{row.value}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* 近隣情報 アコーディオン */}
            {(()=>{
              const LOCAL_AREAS = [
                {
                  area:"明野エリア", color:"#2d6a4f", bg:"#f0fdf4", border:"#86efac",
                  shops:[
                    { name:"あけの農さん物直売所",     desc:"新鮮な野菜果物、レストランは野菜カレーがおすすめ", url:"https://www.google.com/maps/search/?api=1&query=%E5%B1%B1%E6%A2%A8%E7%9C%8C%E5%8C%97%E6%9D%9C%E5%B8%82%E6%98%8E%E9%87%8E%E7%94%BA%20%E3%81%82%E3%81%91%E3%81%AE%E8%BE%B2%E3%81%95%E3%82%93%E7%89%A9%E7%9B%B4%E5%A3%B2%E6%89%80" },
                    { name:"Bond Cafe 114",           desc:"田園の絶景なCafe、本日のランチ、スイーツがおすすめ", url:"https://www.google.com/maps/search/?api=1&query=Bond%20Cafe%20114%20%E5%8C%97%E6%9D%9C%E5%B8%82%E6%98%8E%E9%87%8E" },
                    { name:"手作りお菓子工房 ひつじどき", desc:"自宅店舗、美味しいカヌレやキッシュがおすすめ", url:"https://www.google.com/maps/search/?api=1&query=%E6%89%8B%E4%BD%9C%E3%82%8A%E3%81%8A%E8%8F%93%E5%AD%90%E5%B7%A5%E6%88%BF%E3%81%B2%E3%81%A4%E3%81%98%E3%81%A9%E3%81%8D%20%E5%8C%97%E6%9D%9C%E5%B8%82" },
                  ]
                },
                {
                  area:"大泉エリア", color:"#0891b2", bg:"#ecfeff", border:"#67e8f9",
                  shops:[
                    { name:"八ヶ岳セレクト せんのや",          desc:"八ヶ岳のお土産、２種類のランチも絶品のお味、カフェオレをぜひ！", url:"https://www.google.com/maps/search/?api=1&query=%E5%85%AB%E3%83%B6%E5%B2%B3%E3%82%BB%E3%83%AC%E3%82%AF%E3%83%88%20%E3%81%9B%E3%82%93%E3%81%AE%E3%82%84%20%E5%8C%97%E6%9D%9C%E5%B8%82%E5%A4%A7%E6%B3%89" },
                    { name:"ひまわり市場",                      desc:"みなさんご存知、ちょっといいものが売っているマーケット", url:"https://www.google.com/maps/search/?api=1&query=%E3%81%B2%E3%81%BE%E3%82%8F%E3%82%8A%E5%B8%82%E5%A0%B4%20%E5%8C%97%E6%9D%9C%E5%B8%82%E5%A4%A7%E6%B3%89" },
                    { name:"神社の杜のワーキング・プレイス 8MATO", desc:"森の中でコワーキング、ランチもコーヒーもおすすめ", url:"https://www.google.com/maps/search/?api=1&query=8MATO%20%E7%A5%9E%E7%A4%BE%E3%81%AE%E6%9D%9C%20%E5%8C%97%E6%9D%9C%E5%B8%82%E5%A4%A7%E6%B3%89%E7%94%BA%E8%B0%B7%E6%88%B87318" },
                    { name:"Ziccade cafe",                      desc:"田舎の実家にいるみたい、ランチもドリンクもおすすめ", url:"https://www.google.com/maps/search/?api=1&query=Ziccade%20cafe%20%E5%8C%97%E6%9D%9C%E5%B8%82" },
                    { name:"珈琲の時間 大泉焙煎所",               desc:"自家焙煎珈琲の豆やさん、明野農園カフェでも買えます", url:"https://www.google.com/maps/search/?api=1&query=%E7%8F%88%E7%90%B2%E3%81%AE%E6%99%82%E9%96%93%20%E5%A4%A7%E6%B3%89%E7%84%99%E7%85%8E%E6%89%80%20%E5%8C%97%E6%9D%9C%E5%B8%82" },
                  ]
                },
                {
                  area:"武川エリア", color:"#7c3aed", bg:"#f5f3ff", border:"#c4b5fd",
                  shops:[
                    { name:"土間カフェ Tomiyoshi", desc:"古民家の土間でランチ、おすすめはデミグラスハンバーグ！", url:"https://www.google.com/maps/search/?api=1&query=%E5%9C%9F%E9%96%93%E3%82%AB%E3%83%95%E3%82%A7%20Tomiyoshi%20%E5%8C%97%E6%9D%9C%E5%B8%82%E6%AD%A6%E5%B7%9D" },
                    { name:"手打ち蕎麦 満月庵",      desc:"国道沿いの一軒家、店主手打ちのやさしい蕎麦",           url:"https://www.google.com/maps/search/?api=1&query=%E6%89%8B%E6%89%93%E3%81%A1%E8%95%8E%E9%BA%A6%20%E6%BA%80%E6%9C%88%E5%BA%B5%20%E5%8C%97%E6%9D%9C%E5%B8%82%E6%AD%A6%E5%B7%9D" },
                  ]
                },
                {
                  area:"小淵沢エリア", color:"#be185d", bg:"#fdf2f8", border:"#f9a8d4",
                  shops:[
                    { name:"ヤツクルベース", desc:"別荘地帯のコワーキングスペース、鳥が遊びに来ます", url:"https://www.google.com/maps/search/?api=1&query=%E3%83%A4%E3%83%84%E3%82%AF%E3%83%AB%E3%83%99%E3%83%BC%E3%82%B9%20%E5%B0%8F%E6%B7%B5%E6%B2%A2" },
                  ]
                },
              ];
              const totalShops = LOCAL_AREAS.reduce((s,a)=>s+a.shops.length,0);
              return (
                <>
                  {/* アコーディオンヘッダー */}
                  <button onClick={()=>setShowLocal(p=>!p)}
                    style={{ width:"100%", background:showLocal?"#f9fafb":"#fff", border:`1.5px solid ${showLocal?"#d1d5db":"#e5e7eb"}`, borderRadius:14, padding:"0.75rem 1rem", marginBottom:"0.6rem", display:"flex", alignItems:"center", gap:"0.7rem", cursor:"pointer", fontFamily:"inherit", textAlign:"left", transition:"all 0.2s" }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={showLocal?"#374151":"#6b7280"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M3 12h18M3 6h18M3 18h18"/>
                    </svg>
                    <div style={{ flex:1 }}>
                      <div style={{ fontWeight:700, color:"#374151", fontSize:"0.88rem" }}>近隣情報</div>
                      <div style={{ color:"#9ca3af", fontSize:"0.72rem" }}>北杜市の仲間たち　{totalShops}店舗・施設</div>
                    </div>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      {showLocal ? <polyline points="18 15 12 9 6 15"/> : <polyline points="6 9 12 15 18 9"/>}
                    </svg>
                  </button>
                  {/* 展開パネル */}
                  {showLocal&&(
                    <div style={{ background:"#fff", borderRadius:14, padding:"1rem", marginBottom:"1rem", boxShadow:"0 2px 10px rgba(0,0,0,0.06)", border:"1.5px solid #e5e7eb", animation:"fadeIn 0.3s ease" }}>
                      {LOCAL_AREAS.map((a,ai)=>(
                        <div key={ai} style={{ marginBottom: ai<LOCAL_AREAS.length-1?"0.9rem":"0" }}>
                          {/* エリアラベル */}
                          <div style={{ display:"flex", alignItems:"center", gap:"0.4rem", marginBottom:"0.4rem" }}>
                            <div style={{ width:8, height:8, borderRadius:"50%", background:a.color, flexShrink:0 }}/>
                            <span style={{ fontWeight:700, color:a.color, fontSize:"0.75rem", letterSpacing:"0.03em" }}>{a.area}</span>
                            <div style={{ flex:1, height:"1px", background:a.border }}/>
                          </div>
                          {/* 店舗リスト */}
                          <div style={{ paddingLeft:"0.8rem", display:"flex", flexDirection:"column", gap:"0.3rem" }}>
                            {a.shops.map((s,si)=>(
                              <button key={si} onClick={()=>window.open(s.url,"_blank")}
                                style={{ background:a.bg, border:`1px solid ${a.border}`, borderRadius:9, padding:"0.55rem 0.7rem", display:"flex", alignItems:"flex-start", justifyContent:"space-between", gap:"0.5rem", cursor:"pointer", fontFamily:"inherit", textAlign:"left", transition:"opacity 0.15s" }}
                                onMouseOver={e=>e.currentTarget.style.opacity="0.8"}
                                onMouseOut={e=>e.currentTarget.style.opacity="1"}
                              >
                                <div style={{ flex:1, minWidth:0 }}>
                                  <div style={{ fontWeight:700, color:a.color, fontSize:"0.82rem", lineHeight:1.3 }}>{s.name}</div>
                                  {s.desc&&<div style={{ color:"#6b7280", fontSize:"0.72rem", marginTop:"0.15rem", lineHeight:1.4 }}>{s.desc}</div>}
                                </div>
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={a.color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink:0, marginTop:"0.15rem" }}>
                                  <circle cx="12" cy="11" r="3"/><path d="M12 2a9 9 0 00-9 9c0 5.25 9 13 9 13s9-7.75 9-13a9 9 0 00-9-9z"/>
                                </svg>
                              </button>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </>
              );
            })()}

            <div style={{ background:"linear-gradient(135deg,#f0fdf4,#dcfce7)", border:"1.5px solid #86efac", borderRadius:18, padding:"1.2rem", marginBottom:"1rem" }}>
              <div style={{ fontWeight:800, color:"#166534", fontSize:"1rem", marginBottom:"0.8rem" }}>🫐 最盛期の品種</div>
              {peakVarieties.slice(0,3).map(c=>(
                <div key={c.variety} style={{ display:"flex", alignItems:"center", gap:"0.7rem", marginBottom:"0.5rem" }}>
                  <span>✨</span>
                  <div style={{ flex:1 }}>
                    <div style={{ fontWeight:700, color:"#15803d", fontSize:"0.92rem" }}>{c.variety}<span style={{ fontSize:"0.7rem", color:"#4ade80", marginLeft:"0.4rem" }}>{c.type}</span></div>
                    <div style={{ color:"#6b7280", fontSize:"0.72rem" }}>{c.period}</div>
                  </div>
                </div>
              ))}
              <button onClick={()=>setTab("calendar")} style={{ marginTop:"0.8rem", width:"100%", background:"#16a34a", color:"#fff", border:"none", borderRadius:10, padding:"0.6rem", fontWeight:700, fontSize:"0.85rem", cursor:"pointer", fontFamily:"inherit" }}>全19品種のカレンダーを見る →</button>
            </div>
            <ReviewSection/>
          </div>
        </div>
      )}

      {/* CALENDAR */}
      {tab==="calendar"&&(
        <div style={{ animation:"fadeIn 0.4s ease" }}>
          <div style={{ background:"linear-gradient(135deg,#166534,#2d6a4f)", padding:"2rem 1.5rem 1.5rem", textAlign:"center" }}>
            <div style={{ fontSize:"2rem" }}>📅</div>
            <h2 style={{ color:"#fff", fontWeight:900, margin:"0.3rem 0 0.2rem" }}>おすすめコース　栽培品種と食べ頃時期</h2>
            <p style={{ color:"#b7e4c7", fontSize:"0.82rem", margin:"0 0 0.8rem" }}>目安</p>
            <div style={{ display:"flex", gap:"0.7rem", justifyContent:"center" }}>
              <span style={{ background:"rgba(255,255,255,0.15)", color:"#fff", fontSize:"0.78rem", fontWeight:700, padding:"0.3rem 0.8rem", borderRadius:99 }}>🌿 ハイブッシュ系 {highbushCount}品種</span>
              <span style={{ background:"rgba(255,255,255,0.15)", color:"#fff", fontSize:"0.78rem", fontWeight:700, padding:"0.3rem 0.8rem", borderRadius:99 }}>💜 ラビットアイ系 {rabbitCount}品種</span>
            </div>
          </div>
          <div style={{ padding:"0.9rem 1.2rem 0", display:"flex", gap:"0.4rem" }}>
            <button onClick={()=>setCalView("course")} style={{ flex:1, background:calView==="course"?"#2d6a4f":"#fff", color:calView==="course"?"#fff":"#6b7280", border:`1.5px solid ${calView==="course"?"#2d6a4f":"#e5e7eb"}`, borderRadius:99, padding:"0.45rem", cursor:"pointer", fontWeight:700, fontSize:"0.75rem", fontFamily:"inherit", transition:"all 0.2s" }}>🗺️ おすすめコース</button>
            <button onClick={()=>setCalView("list")} style={{ flex:1, background:calView==="list"?"#2d6a4f":"#fff", color:calView==="list"?"#fff":"#6b7280", border:`1.5px solid ${calView==="list"?"#2d6a4f":"#e5e7eb"}`, borderRadius:99, padding:"0.45rem", cursor:"pointer", fontWeight:700, fontSize:"0.75rem", fontFamily:"inherit", transition:"all 0.2s" }}>📋 一覧</button>
            <button onClick={()=>setCalView("chart")} style={{ flex:1, background:calView==="chart"?"#2d6a4f":"#fff", color:calView==="chart"?"#fff":"#6b7280", border:`1.5px solid ${calView==="chart"?"#2d6a4f":"#e5e7eb"}`, borderRadius:99, padding:"0.45rem", cursor:"pointer", fontWeight:700, fontSize:"0.75rem", fontFamily:"inherit", transition:"all 0.2s" }}>🫐 味わいチャート</button>
          </div>
          <div style={{ padding:"0.8rem 1.2rem" }}>
            {calView==="course"?(<DynamicCourses/>):calView==="chart"?(<BlueberryChart/>):(
              <>
                <div style={{ display:"flex", gap:"0.4rem", flexWrap:"wrap", marginBottom:"0.7rem" }}>
                  {Object.entries(statusConfig).map(([k,v])=>(
                    <span key={k} style={{ background:v.bg, color:v.color, border:`1px solid ${v.border}`, padding:"0.2rem 0.6rem", borderRadius:99, fontSize:"0.7rem", fontWeight:700 }}>{v.label}</span>
                  ))}
                </div>
                <div style={{ display:"flex", gap:"0.5rem", marginBottom:"0.8rem" }}>
                  {["すべて","ハイブッシュ系","ラビットアイ系"].map(t=>(
                    <button key={t} onClick={()=>setFilterType(t)} style={{ background:filterType===t?"#2d6a4f":"#fff", color:filterType===t?"#fff":"#6b7280", border:`1.5px solid ${filterType===t?"#2d6a4f":"#e5e7eb"}`, borderRadius:99, padding:"0.3rem 0.75rem", cursor:"pointer", fontWeight:700, fontSize:"0.73rem", fontFamily:"inherit", transition:"all 0.2s" }}>{t}</button>
                  ))}
                </div>
                {(filterType==="すべて"||filterType==="ハイブッシュ系")&&(
                  <div style={{ display:"flex", alignItems:"center", gap:"0.5rem", margin:"0.5rem 0 0.6rem" }}>
                    <div style={{ height:1, flex:1, background:"#d1fae5" }}/><span style={{ color:"#166534", fontWeight:800, fontSize:"0.8rem", whiteSpace:"nowrap" }}>🌿 ハイブッシュ系 — 6月中旬〜8月上旬</span><div style={{ height:1, flex:1, background:"#d1fae5" }}/>
                  </div>
                )}
                {filteredCalendar.filter(c=>c.type==="ハイブッシュ系").map(item=>{
                  const s=statusConfig[item.status]; const tc=typeConfig[item.type];
                  return (
                    <div key={item.no} className="card-hover" style={{ background:"#fff", border:`1.5px solid #e5e7eb`, borderLeft:`4px solid ${s.border}`, borderRadius:14, padding:"0.75rem 1rem", marginBottom:"0.5rem", boxShadow:"0 1px 6px rgba(0,0,0,0.05)", transition:"all 0.2s", display:"flex", alignItems:"center", gap:"0.7rem" }}>
                      <div style={{ width:26, height:26, borderRadius:"50%", background:tc.bg, border:`1.5px solid ${tc.color}44`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                        <span style={{ color:tc.color, fontWeight:900, fontSize:"0.72rem" }}>{item.no}</span>
                      </div>
                      <div style={{ flex:1 }}>
                        <div style={{ fontWeight:800, color:"#1f2937", fontSize:"0.95rem" }}>{item.variety}</div>
                        <div style={{ color:"#6b7280", fontSize:"0.72rem", marginTop:"0.1rem" }}>📆 {item.period}</div>
                      </div>
                      <span style={{ background:s.bg, color:s.color, border:`1px solid ${s.border}`, padding:"0.18rem 0.55rem", borderRadius:99, fontSize:"0.7rem", fontWeight:700, whiteSpace:"nowrap" }}>{s.label}</span>
                    </div>
                  );
                })}
                {(filterType==="すべて"||filterType==="ラビットアイ系")&&(
                  <div style={{ display:"flex", alignItems:"center", gap:"0.5rem", margin:"1rem 0 0.6rem" }}>
                    <div style={{ height:1, flex:1, background:"#e9d5ff" }}/><span style={{ color:"#6b21a8", fontWeight:800, fontSize:"0.8rem", whiteSpace:"nowrap" }}>💜 ラビットアイ系 — 8月上旬〜9月上旬</span><div style={{ height:1, flex:1, background:"#e9d5ff" }}/>
                  </div>
                )}
                {filteredCalendar.filter(c=>c.type==="ラビットアイ系").map(item=>{
                  const s=statusConfig[item.status]; const tc=typeConfig[item.type];
                  return (
                    <div key={item.no} className="card-hover" style={{ background:"#fff", border:`1.5px solid #e5e7eb`, borderLeft:`4px solid ${s.border}`, borderRadius:14, padding:"0.75rem 1rem", marginBottom:"0.5rem", boxShadow:"0 1px 6px rgba(0,0,0,0.05)", transition:"all 0.2s", display:"flex", alignItems:"center", gap:"0.7rem" }}>
                      <div style={{ width:26, height:26, borderRadius:"50%", background:tc.bg, border:`1.5px solid ${tc.color}44`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                        <span style={{ color:tc.color, fontWeight:900, fontSize:"0.72rem" }}>{item.no}</span>
                      </div>
                      <div style={{ flex:1 }}>
                        <div style={{ fontWeight:800, color:"#1f2937", fontSize:"0.95rem" }}>{item.variety}</div>
                        <div style={{ color:"#6b7280", fontSize:"0.72rem", marginTop:"0.1rem" }}>📆 {item.period}</div>
                      </div>
                      <span style={{ background:s.bg, color:s.color, border:`1px solid ${s.border}`, padding:"0.18rem 0.55rem", borderRadius:99, fontSize:"0.7rem", fontWeight:700, whiteSpace:"nowrap" }}>{s.label}</span>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </div>
      )}

      {/* CAFE */}
      {tab==="cafe"&&(
        <div style={{ animation:"fadeIn 0.4s ease" }}>
          <div style={{ background:"linear-gradient(135deg,#78350f,#a16207)", padding:"1.5rem 1.5rem 1.2rem", textAlign:"center" }}>
            <h2 style={{ color:"#fff", fontWeight:900, margin:"0 0 0.2rem", fontSize:"1.3rem" }}>カフェメニュー</h2>
            <p style={{ color:"#fde68a", fontSize:"0.8rem", margin:0 }}>農園Cafe（冷房完備）</p>
          </div>
          <div style={{ padding:"0.8rem 1.2rem 0", display:"flex", gap:"0.5rem" }}>
            <button onClick={()=>setCafeView("menu")} style={{ flex:1, background:cafeView==="menu"?"#78350f":"#fff", color:cafeView==="menu"?"#fff":"#6b7280", border:`1.5px solid ${cafeView==="menu"?"#78350f":"#e5e7eb"}`, borderRadius:99, padding:"0.42rem", cursor:"pointer", fontWeight:700, fontSize:"0.8rem", fontFamily:"inherit", transition:"all 0.2s" }}>注文する</button>
            <button onClick={()=>setCafeView("chart")} style={{ flex:1, background:cafeView==="chart"?"#78350f":"#fff", color:cafeView==="chart"?"#fff":"#6b7280", border:`1.5px solid ${cafeView==="chart"?"#78350f":"#e5e7eb"}`, borderRadius:99, padding:"0.42rem", cursor:"pointer", fontWeight:700, fontSize:"0.8rem", fontFamily:"inherit", transition:"all 0.2s" }}>珈琲チャート</button>
          </div>
          <div style={{ padding:"0.8rem 1.2rem" }}>
            {cafeView==="chart"?<CoffeeChart/>:(
              <>
                {/* メニューリスト */}
                {["おすすめ","定番","お土産"].map(cat=>(
                  <div key={cat} style={{ marginBottom:"0.8rem" }}>
                    <div style={{ display:"flex", alignItems:"center", gap:"0.5rem", marginBottom:"0.5rem" }}>
                      <div style={{ height:1, flex:1, background:"#e5e7eb" }}/>
                      <span style={{ fontWeight:700, color: cat==="お土産"?"#166534":"#78350f", fontSize:"0.78rem" }}>{cat==="お土産"?"🛍️ お土産":cat}</span>
                      <div style={{ height:1, flex:1, background:"#e5e7eb" }}/>
                    </div>
                    {MENU_ITEMS.filter(m=>m.category===cat).map(item=>(
                      <div key={item.id} style={{ background:"#fff", borderRadius:14, padding:"0.75rem 0.9rem", marginBottom:"0.5rem", boxShadow:"0 1px 6px rgba(0,0,0,0.05)", display:"flex", alignItems:"center", gap:"0.7rem" }}>
                        <span style={{ fontSize:"1.4rem" }}>{item.emoji}</span>
                        <div style={{ flex:1 }}>
                          <div style={{ fontWeight:700, color:"#1f2937", fontSize:"0.88rem" }}>{item.name}</div>
                          <div style={{ fontWeight:600, color:"#78350f", fontSize:"0.85rem" }}>¥{item.price.toLocaleString()}</div>
                        </div>
                        <div style={{ display:"flex", alignItems:"center", gap:"0.35rem" }}>
                          <button onClick={()=>updateOrder(item.id,-1)} style={{ width:28, height:28, borderRadius:"50%", border:"1.5px solid #78350f", background:"#fff", color:"#78350f", fontWeight:900, fontSize:"1.1rem", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", lineHeight:1 }}>−</button>
                          <span style={{ fontWeight:800, minWidth:22, textAlign:"center", fontSize:"1rem" }}>{orders[item.id]||0}</span>
                          <button onClick={()=>updateOrder(item.id,1)} style={{ width:28, height:28, borderRadius:"50%", border:"none", background:"#78350f", color:"#fff", fontWeight:900, fontSize:"1.1rem", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", lineHeight:1 }}>＋</button>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}

                {/* カート：注文確定ボタン */}
                {totalOrder>0&&(
                  <div style={{ background:"linear-gradient(135deg,#fef3c7,#fde68a)", border:"1.5px solid #fcd34d", borderRadius:16, padding:"1rem", marginBottom:"1rem" }}>
                    <div style={{ fontWeight:800, color:"#92400e", marginBottom:"0.5rem", fontSize:"0.88rem" }}>注文内容</div>
                    {MENU_ITEMS.filter(m=>(orders[m.id]||0)>0).map(item=>(
                      <div key={item.id} style={{ display:"flex", justifyContent:"space-between", fontSize:"0.84rem", color:"#78350f", marginBottom:"0.2rem" }}>
                        <span>{item.emoji} {item.name} × {orders[item.id]}</span>
                        <span style={{ fontWeight:700 }}>¥{(item.price*orders[item.id]).toLocaleString()}</span>
                      </div>
                    ))}
                    <div style={{ borderTop:"1px solid #fcd34d", marginTop:"0.5rem", paddingTop:"0.5rem", display:"flex", justifyContent:"space-between", fontWeight:900, color:"#92400e" }}>
                      <span>今回の小計</span><span>¥{totalOrder.toLocaleString()}</span>
                    </div>
                    <button onClick={()=>{
                      const items = MENU_ITEMS.filter(m=>(orders[m.id]||0)>0).map(m=>({
                        id:m.id, name:m.name, emoji:m.emoji,
                        qty:orders[m.id], price:m.price, subtotal:m.price*orders[m.id]
                      }));
                      const round = { items, subtotal:totalOrder, time:new Date().toLocaleTimeString("ja-JP",{hour:"2-digit",minute:"2-digit"}) };
                      setOrderHistory(prev=>[...prev, round]);
                      setOrders({});
                      setOrderSubmitted(true);
                      fetch("https://api.emailjs.com/api/v1.0/email/send",{
                        method:"POST", headers:{"Content-Type":"application/json"},
                        body:JSON.stringify({
                          service_id:EMAILJS_SERVICE_ID, template_id:EMAILJS_TEMPLATE_ID, user_id:EMAILJS_PUBLIC_KEY,
                          template_params:{
                            type:"☕ カフェ注文",
                            name:"カフェ",
                            details:items.map(m=>m.name+" x "+m.qty).join("\n")+" \n小計:¥"+totalOrder.toLocaleString(),
                            datetime:new Date().toLocaleString("ja-JP"),
                            to_email:"om.kc.order@gmail.com",
                            cc_email:"bluesky.ari150842@gmail.com",
                          }
                        })
                      }).catch(()=>{});
                      // GASに注文保存（キッチンディスプレイ用）
                      gasPost({
                        action:"saveOrder",
                        deviceId: DEVICE_ID,
                        guestName: checkin?.name || "ゲスト",
                        items: items.map(m=>({ id:m.id, name:m.name, qty:m.qty, price:m.price, subtotal:m.subtotal })),
                        total: totalOrder,
                      }).catch(()=>{});
                    }} style={{ marginTop:"0.8rem", width:"100%", background:"#92400e", color:"#fff", border:"none", borderRadius:12, padding:"0.7rem", fontWeight:900, fontSize:"0.9rem", cursor:"pointer", fontFamily:"inherit" }}>
                      注文を確定する ✓
                    </button>
                  </div>
                )}

                {/* 確定済み通知 */}
                {orderSubmitted&&totalOrder===0&&(
                  <div style={{ background:"#dcfce7", border:"1.5px solid #86efac", borderRadius:12, padding:"0.8rem 1rem", marginBottom:"1rem", display:"flex", alignItems:"center", gap:"0.6rem", animation:"fadeIn 0.3s ease" }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                    <div>
                      <div style={{ fontWeight:700, color:"#166534", fontSize:"0.88rem" }}>注文を受け付けました！</div>
                      <button onClick={()=>setOrderSubmitted(false)} style={{ background:"none", border:"none", color:"#4ade80", fontSize:"0.75rem", cursor:"pointer", padding:0, fontFamily:"inherit" }}>続けて注文する</button>
                    </div>
                  </div>
                )}

                {/* 累積注文履歴・合計 */}
                {orderHistory.length>0&&(
                  <div style={{ background:"#fff", borderRadius:16, padding:"1rem", boxShadow:"0 2px 10px rgba(0,0,0,0.06)", marginBottom:"1rem" }}>
                    <div style={{ fontWeight:800, color:"#1f2937", fontSize:"0.9rem", marginBottom:"0.7rem" }}>本日の注文合計</div>
                    {orderHistory.map((round, ri)=>(
                      <div key={ri} style={{ marginBottom:"0.6rem", paddingBottom:"0.6rem", borderBottom: ri<orderHistory.length-1?"1px solid #f3f4f6":"none" }}>
                        <div style={{ color:"#9ca3af", fontSize:"0.7rem", marginBottom:"0.3rem", fontWeight:600 }}>{round.time}　第{ri+1}回注文</div>
                        {round.items.map(item=>(
                          <div key={item.id} style={{ display:"flex", justifyContent:"space-between", fontSize:"0.82rem", color:"#4b5563", marginBottom:"0.15rem" }}>
                            <span>{item.emoji} {item.name} × {item.qty}</span>
                            <span>¥{item.subtotal.toLocaleString()}</span>
                          </div>
                        ))}
                        <div style={{ display:"flex", justifyContent:"space-between", fontSize:"0.8rem", color:"#78350f", fontWeight:700, marginTop:"0.2rem" }}>
                          <span>小計</span><span>¥{round.subtotal.toLocaleString()}</span>
                        </div>
                      </div>
                    ))}
                    {/* 累積合計 */}
                    <div style={{ background:"linear-gradient(135deg,#78350f,#a16207)", borderRadius:12, padding:"0.8rem 1rem", marginTop:"0.5rem", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                      <span style={{ color:"#fde68a", fontWeight:700, fontSize:"0.88rem" }}>累計合計</span>
                      <span style={{ color:"#fff", fontWeight:900, fontSize:"1.3rem" }}>¥{orderHistory.reduce((s,r)=>s+r.subtotal,0).toLocaleString()}</span>
                    </div>
                  </div>
                )}

                <p style={{ color:"#9ca3af", fontSize:"0.73rem", textAlign:"center" }}>※ 価格はすべて税込です</p>
              </>
            )}
          </div>
        </div>
      )}

      {/* STAMP */}
      {tab==="stamp"&&(
        <StampRally guestName={""} />
      )}
      {/* Bottom nav - LINE風スケルトンアイコン */}
      <div style={{ position:"fixed", bottom:0, left:"50%", transform:"translateX(-50%)", width:"100%", maxWidth:480, background:"rgba(255,255,255,0.97)", backdropFilter:"blur(16px)", borderTop:"1px solid #e5e7eb", display:"flex", padding:"0.3rem 0 0.5rem", zIndex:100 }}>
        {[
          { id:"home", label:"ホーム", icon:(active)=>(
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active?"#2d6a4f":"#9ca3af"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 12L12 3l9 9"/>
              <path d="M9 21V12h6v9"/>
              <path d="M3 12v9h18V12"/>
            </svg>
          )},
          { id:"calendar", label:"食べ頃", icon:(active)=>(
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active?"#2d6a4f":"#9ca3af"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
              <circle cx="8" cy="15" r="1" fill={active?"#2d6a4f":"#9ca3af"}/>
              <circle cx="12" cy="15" r="1" fill={active?"#2d6a4f":"#9ca3af"}/>
              <circle cx="16" cy="15" r="1" fill={active?"#2d6a4f":"#9ca3af"}/>
            </svg>
          )},
          { id:"cafe", label:"カフェ", icon:(active)=>(
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active?"#2d6a4f":"#9ca3af"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M17 8h1a4 4 0 010 8h-1"/>
              <path d="M3 8h14v9a4 4 0 01-4 4H7a4 4 0 01-4-4V8z"/>
              <line x1="6" y1="2" x2="6" y2="5"/>
              <line x1="10" y1="2" x2="10" y2="5"/>
              <line x1="14" y1="2" x2="14" y2="5"/>
            </svg>
          )},
          { id:"stamp", label:"スタンプ", icon:(active)=>(
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active?"#2d6a4f":"#9ca3af"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="8" r="5"/>
              <path d="M3 21h18"/>
              <path d="M7 21v-4a5 5 0 0110 0v4"/>
              <circle cx="12" cy="8" r="2" fill={active?"#2d6a4f":"none"} strokeWidth="1.5"/>
            </svg>
          )},
        ].map(t=>{
          const active = tab===t.id;
          return (
            <button key={t.id} className="tab-btn" onClick={()=>setTab(t.id)}
              style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", gap:"0.2rem", border:"none", background:"transparent", cursor:"pointer", transition:"transform 0.15s", padding:"0.3rem 0" }}>
              {t.icon(active)}
              <span style={{ fontSize:"0.6rem", fontWeight:active?700:400, color:active?"#2d6a4f":"#9ca3af", letterSpacing:"0.01em" }}>{t.label}</span>
              {active&&<div style={{ width:18, height:2, borderRadius:99, background:"#2d6a4f", marginTop:"0.05rem" }}/>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
